import React, { useEffect, useRef, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from '../../helpers/toast';

import { jwtDecode } from 'jwt-decode';
import Navbar from '../../components/Navbar/Navbar';
import { useAuth } from '../../context/AuthContext';
import {
    getMyCareer,
    createCareer,
    getCareerClubOptions,
    chooseCareerClub,
    sendCareerTransferDecision,
    adminGoToClub,
    deleteCareer,
    saveCareerState,
    getCareerMaintenance,
    getAchievements,
    syncAchievements,
    getSeleccionesConfig,
} from '../../services/api';
// Motor de simulación corriendo EN EL NAVEGADOR (copia ESM del backend). Cada "simular" es un
// cálculo local instantáneo sobre la carrera en memoria; el guardado va en 2º plano.
import { runTurn, finalizeOtherLeagues, prunePlayedFixtures, computeSeleccionNext } from '../../career2/careerTurn';
import { roundsForCount } from '../../career2/calendar';
import * as PM from '../../career2/playerModel';
import { elegirEvento, resolverOpcion, interp } from '../../career2/eventos';
import { FORMACIONES, ACTITUDES, PRESIONES, ESTILOS, MARCAS, TACTICA_LABEL, defaultTacticas, rivalTacticas, scoutingHint } from '../../career2/matchEngine';
import { evaluarLogros } from '../../career2/logros';
import { LOGROS, LOGROS_BY_KEY, TIERS, TIER_LABEL } from '../../career2/logrosDefs';
import { PlayerAvatar, avatarToDataUri, AVATAR_DEFAULT, PEINADOS, BARBAS, LENTES, ATUENDOS, PATRONES, BOTIN_ESTILOS, ACCESORIOS } from '../../components/PlayerAvatar/PlayerAvatar';
import { seleccionDelJugador, isCalledUp as isCalledUpSeleccion, NACIONALIDADES, CODIGO_PAIS, SELECCIONES_BY_PAIS, aplicarOverridesSelecciones } from '../../career2/selecciones';
import { ordenarStandings as ordenarStandingsSel } from '../../career2/seleccionEngine';
import './CareerSimulatorPage2.css';

const POSITIONS = PM.POSICIONES;

const POSITION_ABBR = {
    'Defensor Lateral': 'LAT',
    'Defensor Central': 'DFC',
    'Mediocampista Defensivo': 'MCD',
    'Mediocampista Ofensivo': 'MCO',
    'Delantero Extremo': 'EXT',
    'Delantero Centro': 'DC',
};

// Físico inicial sugerido por posición (el del primer prototipo ideal).
const FISICO_DEFAULT = { altura: 178, peso: 75 };

// Todas las nacionalidades jugables + códigos de bandera vienen del catálogo de selecciones
// (203 países). Importado para no duplicar.
const NATIONALITIES = NACIONALIDADES;

function getFlagUrl(nacionalidad) {
    const code = CODIGO_PAIS[nacionalidad];
    return code ? `https://flagcdn.com/24x18/${code}.png` : null;
}

// Colores rápidos (los más comunes) por categoría. Para cualquier otro color, el ColorRow abre
// el selector RGB nativo (input type=color).
const QUICK_PIEL = ['#f5d3a8', '#e0ac69', '#8d5524', '#3b2417'];
const QUICK_PELO = ['#2d1b0e', '#0d0d0d', '#c98a2c', '#b22222'];
const QUICK_COLOR = ['#dc2626', '#2563eb', '#16a34a', '#ffffff'];
const QUICK_BOTIN = ['#111111', '#ffffff', '#dc2626', '#facc15'];
const QUICK_LENTES = ['#1f2937', '#111827', '#dc2626', '#2563eb'];

// Fila de color: unos pocos swatches rápidos + un botón "personalizado" que abre el panel RGB.
function ColorRow({ value, quick, onChange, label }) {
    const v = (value || '').toLowerCase();
    const inList = quick.some((c) => c.toLowerCase() === v);
    return (
        <div className="cs-swatch-row">
            {quick.map((c) => (
                <button
                    key={c}
                    type="button"
                    className={`cs-swatch${v === c.toLowerCase() ? ' active' : ''}`}
                    style={{ background: c }}
                    onClick={() => onChange(c)}
                    aria-label={`${label} ${c}`}
                />
            ))}
            <label
                className={`cs-swatch cs-swatch-custom${!inList ? ' active' : ''}`}
                title="Elegir otro color"
                style={!inList ? { background: value } : undefined}
            >
                <input type="color" value={value || '#ffffff'} onChange={(e) => onChange(e.target.value)} />
            </label>
        </div>
    );
}

// Reglas de clasificación por confederación: q = posiciones que van DIRECTO al Mundial,
// po = posiciones que van al repechaje. El resto queda eliminado. Para mostrar leyenda + colores.
const CLASIF_RULES = {
    UEFA:     { q: [1], po: [2, 3], texto: '1º → Mundial · 2º (y mejores 3º) → Repechaje · resto afuera',
                detalle: '12 grupos. El 1º de cada grupo va directo al Mundial (12 cupos). Los 12 segundos + los 4 mejores terceros juegan un repechaje por los 4 cupos restantes.',
                repechaje: { cual: 'segundos', n: 12, sub: '(+ 4 mejores terceros)' } },
    Asia:     { q: [1, 2], po: [3], texto: '1º y 2º → Mundial · mejor 3º → Repechaje · resto afuera',
                detalle: '4 grupos. El 1º y el 2º de cada grupo van directo al Mundial (8 cupos). Los 4 terceros juegan un repechaje por 1 cupo.',
                repechaje: { cual: 'terceros', n: 4 } },
    Africa:   { q: [1], po: [2], texto: '1º → Mundial · 4 mejores 2º → Repechaje · resto afuera',
                detalle: '9 grupos. El 1º de cada grupo va directo al Mundial (9 cupos). Los 4 MEJORES segundos (entre los 9 grupos) juegan un repechaje a partido único; el ganador se lleva el 10º y último cupo africano.',
                repechaje: { cual: 'segundos', n: 4 } },
    CONCACAF: { q: [1], po: [2], texto: '1º → Mundial · 2º → Repechaje cruzado · resto afuera',
                detalle: '4 grupos. El 1º de cada grupo va directo al Mundial (4 cupos). Los 4 segundos se cruzan (G1-G3, G2-G4) a ida y vuelta por los 2 cupos restantes.',
                repechaje: { cual: 'segundos', n: 4 } },
    Conmebol: { q: [1, 2, 3, 4, 5, 6], po: [], texto: '1º a 6º → Mundial · resto afuera',
                detalle: 'Liga única (todos contra todos). Los primeros 6 de la tabla van directo al Mundial.' },
    Oceania:  { q: [1], po: [], texto: '1º → Mundial · resto afuera',
                detalle: 'Liga única (todos contra todos). Solo el 1º de la tabla va al Mundial.' },
};
const MUNDIAL_GRUPO_RULES = { q: [1, 2], po: [3], texto: '1º y 2º → 16avos · mejores 3º también' };
const clasifPosClass = (reglas, pos) => (reglas?.q?.includes(pos) ? 'sel-q' : reglas?.po?.includes(pos) ? 'sel-po' : '');

// Panel de tabla colapsable: el título es clickeable para mostrar/ocultar la tabla (útil sobre
// todo en mobile). `extra` se muestra entre el título y el contenido (p. ej. la nota de fase).
function Colapsable({ titulo, extra = null, children, defaultOpen = true }) {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div className="cs-standings cs-panel">
            <h2 className="cs-section-title cs-collapse-head" onClick={() => setOpen((o) => !o)} role="button" tabIndex={0}>
                <span className="cs-collapse-title">{titulo}</span>
                <span className="cs-collapse-chevron">{open ? '▾' : '▸'}</span>
            </h2>
            {open && extra}
            {open && children}
        </div>
    );
}

// El backend lleva el mes de la temporada (career.mes, calendario europeo 1-12).
const KO_RONDA_LABEL = {
    '16avos': '16avos de final',
    octavos: 'Octavos de final',
    cuartos: 'Cuartos de final',
    semis: 'Semifinal',
    final: 'Final',
};

// Ícono por competición continental (Champions/Europa europeas + Libertadores/Sudamericana).
const COPA_ICON = {
    champions: '🏆',
    europa: '🌍',
    libertadores: '🏆',
    sudamericana: '🥈',
    seleccion: '🌍',
};
const copaIcon = (competicion) => COPA_ICON[competicion] || '🏆';

const MES_NOMBRES = {
    1: 'Enero', 2: 'Febrero', 3: 'Marzo', 4: 'Abril', 5: 'Mayo', 6: 'Junio',
    7: 'Julio', 8: 'Agosto', 9: 'Septiembre', 10: 'Octubre', 11: 'Noviembre', 12: 'Diciembre',
};

const SIM_SPEED_KEY = 'cs-sim-speed';

function randomMinute() {
    return Math.floor(Math.random() * 90) + 1;
}

// Arma el estado inicial de la animación de partido en vivo a partir del resultado ya simulado.
function buildLiveMatch(partidoJugador, career, jornada, rivalLogo) {
    const { local, gf, gc, rival_nombre } = partidoJugador;
    // Si es partido de SELECCIÓN, los "logos" son banderas de los países (no escudos de clubes).
    const esSeleccion = partidoJugador.competicion === 'clasificatoria' || partidoJugador.competicion === 'playoff'
        || partidoJugador.competicion === 'preplayoff'
        || partidoJugador.competicion === 'mundial-grupo' || partidoJugador.competicion === 'mundial-ko';
    const miNombre = esSeleccion ? career.nacionalidad : career.club_actual?.nombre;
    const miLogo = esSeleccion ? getFlagUrl(career.nacionalidad) : career.club_actual?.logo;
    const rivLogo = esSeleccion ? getFlagUrl(partidoJugador.rival_pais || rival_nombre) : rivalLogo;
    const homeNombre = local ? miNombre : rival_nombre;
    const awayNombre = local ? rival_nombre : miNombre;
    const homeLogo = local ? miLogo : rivLogo;
    const awayLogo = local ? rivLogo : miLogo;
    const homeGoals = local ? gf : gc;
    const awayGoals = local ? gc : gf;

    // Goles de mi equipo: los primeros son MÍOS (gol), los siguientes asistencia MÍA, el resto
    // del equipo. Así en la animación se ve el minuto y si el gol/asistencia fue tuyo.
    const miTeam = local ? 'home' : 'away';
    const otroTeam = local ? 'away' : 'home';
    const misGoles = local ? homeGoals : awayGoals;
    const otrosGoles = local ? awayGoals : homeGoals;
    const golesJug = partidoJugador.goles_jugador || 0;
    const asisJug = partidoJugador.asistencias_jugador || 0;

    const events = [];
    for (let i = 0; i < misGoles; i++) {
        let tipo = 'equipo';
        if (i < golesJug) tipo = 'gol';
        else if (i < golesJug + asisJug) tipo = 'asistencia';
        events.push({ team: miTeam, minute: randomMinute(), mio: tipo !== 'equipo', tipo });
    }
    for (let i = 0; i < otrosGoles; i++) events.push({ team: otroTeam, minute: randomMinute(), mio: false, tipo: 'rival' });
    events.sort((a, b) => a.minute - b.minute);

    // En la vuelta de una eliminatoria, parcial de la ida = global − lo de este partido.
    let idaResultado = null;
    if (partidoJugador.leg === 'vuelta' && partidoJugador.global_favor != null) {
        idaResultado = { favor: partidoJugador.global_favor - gf, contra: partidoJugador.global_contra - gc };
    }

    // Si el partido se definió por penales (eliminatoria), guardamos la tanda para animarla
    // penal por penal cuando termina el tiempo regular.
    const penales = partidoJugador.penal_tanda ? {
        tanda: partidoJugador.penal_tanda,
        favor: partidoJugador.penal_favor,
        contra: partidoJugador.penal_contra,
        avanzo: partidoJugador.avanzo,
    } : null;

    // Encabezado del partido: si es internacional, mostramos la copa y la instancia (fase de
    // grupos / octavos / cuartos / semis / final + ida o vuelta), NO "Jornada X · Local".
    let header;
    if (partidoJugador.competicion === 'clasificatoria') {
        header = `🌍 Eliminatorias Mundial · Año ${partidoJugador.año_ciclo}/3${partidoJugador.no_convocado ? ' · 🚫 No convocado' : ''}`;
    } else if (partidoJugador.competicion === 'preplayoff') {
        header = `🌍 Pre-repechaje CONCACAF · ${partidoJugador.ronda || ''}`;
    } else if (partidoJugador.competicion === 'playoff') {
        const legTxt = partidoJugador.leg === 'ida' ? ' · Ida' : partidoJugador.leg === 'vuelta' ? ' · Vuelta' : '';
        header = `🌍 Repechaje Mundial · ${partidoJugador.ronda || ''}${legTxt}`;
    } else if (partidoJugador.competicion === 'mundial-grupo' || partidoJugador.competicion === 'mundial-ko') {
        const inst = partidoJugador.competicion === 'mundial-grupo'
            ? `Fase de grupos · Fecha ${partidoJugador.fecha || '?'}`
            : (KO_RONDA_LABEL[partidoJugador.ronda] || partidoJugador.ronda || 'Eliminatoria');
        header = `🌍 Mundial · ${inst}`;
    } else if (partidoJugador.competicion) {
        const COPA_NOMBRE_LIVE = { champions: 'Champions League', europa: 'Europa League', libertadores: 'Copa Libertadores', sudamericana: 'Copa Sudamericana' };
        const copa = `${copaIcon(partidoJugador.competicion)} ${COPA_NOMBRE_LIVE[partidoJugador.competicion] || 'Copa'}`;
        let faseTxt;
        if (partidoJugador.fase === 'knockout') {
            const ronda = KO_RONDA_LABEL[partidoJugador.ronda] || partidoJugador.ronda;
            const legTxt = partidoJugador.leg === 'ida' ? ' · Ida' : partidoJugador.leg === 'vuelta' ? ' · Vuelta' : '';
            faseTxt = `${ronda}${legTxt}`;
        } else {
            faseTxt = 'Fase de grupos';
        }
        header = `${copa} · ${faseTxt}`;
    } else {
        header = `Jornada ${jornada} · ${local ? 'Local' : 'Visitante'}`;
    }

    return {
        jornada,
        local,
        header,
        homeNombre,
        awayNombre,
        homeLogo,
        awayLogo,
        events,
        idaResultado,
        currentMinute: 0,
        homeScore: 0,
        awayScore: 0,
        finished: false,
        penales,
        penalStep: 0,
        planFeedback: partidoJugador.plan_feedback || null,
        esSeleccion,
    };
}

// Avatar del jugador: el sistema vive en components/PlayerAvatar (DiceBear + cuerpo de
// futbolista). Acá solo se importan AVATAR_DEFAULT, las listas de opciones y PlayerAvatar.

// Estrellitas compactas (llena / media / vacía). La media se pinta de verdad (mitad de la estrella).
function MiniStars({ value }) {
    const full = Math.floor(value);
    const half = value - full >= 0.5;
    const stars = [];
    for (let i = 0; i < 5; i++) {
        let cls = 'cs-mini-star';
        if (i < full) cls += ' is-full';
        else if (i === full && half) cls += ' is-half';
        stars.push(<span key={i} className={cls}>★</span>);
    }
    return <span className="cs-mini-stars" aria-label={`${value} estrellas`}>{stars}</span>;
}

function StarRating({ value }) {
    const full = Math.floor(value);
    const half = value - full >= 0.5;
    const stars = [];
    for (let i = 0; i < 5; i++) {
        if (i < full) {
            stars.push(<span key={i} className="cs-star">★</span>);
        } else if (i === full && half) {
            stars.push(
                <span key={i} className="cs-star cs-star--half">
                    ☆<span className="cs-star-fill">★</span>
                </span>
            );
        } else {
            stars.push(<span key={i} className="cs-star">☆</span>);
        }
    }
    return (
        <span className="cs-stars">
            {stars} <span className="cs-stars-value">({half ? full + 0.5 : full})</span>
        </span>
    );
}

// Base pública de tu CDN R2 (imágenes propias, cacheadas). Es una URL pública, no un secreto.
const R2_PUBLIC = 'https://images.footy-games.com.ar';

// Reescribe una URL de logo del CDN de Transfermarkt (…/wappen/big/12345.png) a tu R2
// (images.footy-games.com.ar/clubs/12345.png). Si no es una URL de TM, la deja igual. Así
// los escudos se sirven desde TU CDN cacheado sin migrar nada en la base.
function toR2Logo(url) {
    if (!url) return url;
    const m = url.match(/\/wappen\/(?:big|head|normal|small)\/(\d+)\.png/i);
    return m ? `${R2_PUBLIC}/clubs/${m[1]}.png` : url;
}

function ClubCrest({ logo, nombre, className = 'cs-crest' }) {
    const [src, setSrc] = useState(() => toR2Logo(logo));
    const [hidden, setHidden] = useState(false);
    // Si cambia el club (re-render con otro logo), reseteamos el estado de la imagen.
    useEffect(() => { setSrc(toR2Logo(logo)); setHidden(false); }, [logo]);

    if (!logo || hidden) {
        return <div className={`${className} cs-crest--placeholder`}>⚽</div>;
    }
    return (
        <img
            className={className}
            src={src}
            alt={nombre}
            loading="lazy"
            decoding="async"
            // Si el logo no está en R2 (404), caemos a la URL original (TM); si esa también
            // falla, mostramos el placeholder. Nunca queda peor que antes.
            onError={() => { if (src !== logo) setSrc(logo); else setHidden(true); }}
        />
    );
}

// Lista plana de todos los clubes de todas las ligas de la partida, para el selector de
// "ir a cualquier club" de admin.
function getAllClubsFlat(career) {
    if (!career?.leagues) return [];
    const out = [];
    for (const league of career.leagues) {
        for (const club of league.clubs || []) {
            out.push({
                tm_id: club.tm_id,
                nombre: club.nombre,
                logo: club.logo,
                estrellas: club.estrellas,
                pais: league.pais,
                division: league.division,
                liga_nombre: league.nombre,
            });
        }
    }
    return out;
}

// Tabla de posiciones reutilizable. view: 'liga' | 'champions' | 'europa' (define las zonas coloreadas).
function StandingsTable({ data, view, careerTmId }) {
    return (
        <>
            <div className="cs-table-scroll">
                <table className="cs-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th className="cs-table-club">Club</th>
                            <th>PJ</th><th>PG</th><th>PE</th><th>PP</th><th>GF</th><th>GC</th><th>DG</th><th>Pts</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.tabla.map((club, idx) => {
                            const pos = idx + 1;
                            let zone = '';
                            if (view === 'liga') {
                                if (data.cupos_libertadores && pos <= data.cupos_libertadores) zone = 'libertadores';
                                else if (data.cupos_sudamericana && pos <= data.cupos_libertadores + data.cupos_sudamericana) zone = 'sudamericana';
                                else if (data.cupos_champions && pos <= data.cupos_champions) zone = 'champions';
                                else if (data.cupos_europa && pos <= data.cupos_champions + data.cupos_europa) zone = 'europa';
                                else if (data.ascensos && pos <= data.ascensos) zone = 'ascenso';
                                else if (data.descensos && pos > data.tabla.length - data.descensos) zone = 'descenso';
                            } else {
                                if (pos <= 8) zone = 'octavos';
                                else if (pos <= 24) zone = 'dieciseisavos';
                                else zone = 'eliminado';
                            }
                            const isCurrent = club.tm_id === careerTmId;
                            return (
                                <tr
                                    key={`${club.tm_id || club.nombre}-${idx}`}
                                    className={`cs-table-row${zone ? ` cs-table-row--${zone}` : ''}${isCurrent ? ' cs-table-row--current' : ''}`}
                                >
                                    <td><span className={`cs-pos-badge${zone ? ` cs-pos-badge--${zone}` : ''}`}>{pos}</span></td>
                                    <td className="cs-table-club">
                                        <span className="cs-table-club-inner">
                                            <ClubCrest logo={club.logo} nombre={club.nombre} />
                                            <span>{club.nombre}</span>
                                        </span>
                                    </td>
                                    <td>{club.pj}</td><td>{club.pg}</td><td>{club.pe}</td><td>{club.pp}</td>
                                    <td>{club.gf}</td><td>{club.gc}</td><td>{club.gf - club.gc}</td><td>{club.pts}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {view === 'liga' ? (
                <div className="cs-table-legend">
                    {data.cupos_libertadores > 0 && <span><i className="cs-dot cs-dot--libertadores" /> Copa Libertadores</span>}
                    {data.cupos_sudamericana > 0 && <span><i className="cs-dot cs-dot--sudamericana" /> Copa Sudamericana</span>}
                    {data.cupos_champions > 0 && <span><i className="cs-dot cs-dot--champions" /> Champions League</span>}
                    {data.cupos_europa > 0 && <span><i className="cs-dot cs-dot--europa" /> Europa League</span>}
                    {data.ascensos > 0 && <span><i className="cs-dot cs-dot--ascenso" /> Ascenso</span>}
                    {data.descensos > 0 && <span><i className="cs-dot cs-dot--descenso" /> Descenso</span>}
                </div>
            ) : (
                <div className="cs-table-legend">
                    <span><i className="cs-dot cs-dot--octavos" /> Octavos (directo)</span>
                    <span><i className="cs-dot cs-dot--dieciseisavos" /> Playoff 16avos</span>
                    <span><i className="cs-dot cs-dot--eliminado" /> Eliminado</span>
                </div>
            )}
        </>
    );
}

const KO_ORDER = ['16avos', 'octavos', 'cuartos', 'semis', 'final'];
const KO_PAIR_COUNT = { '16avos': 8, octavos: 8, cuartos: 4, semis: 2, final: 1 };

// Eliminatorias subdivididas por instancia: cada ronda (16avos, octavos, …) con sus cruces
// en formato de fila "escudo+nombre  vs  nombre+escudo". Se muestran TODAS las rondas desde
// el arranque de la fase eliminatoria; las que todavía no se definen aparecen con "A definir"
// y se van completando a medida que se conocen los clasificados de la ronda anterior.
function EuroBracket({ data, careerTmId }) {
    const clubById = new Map((data.clubs || []).map((c) => [c.tm_id, c]));
    const decididas = {};
    for (const r of data.ko_resultados || []) (decididas[r.ronda] = decididas[r.ronda] || []).push(r);

    const vivos = data.ko_vivos || [];
    const currentPairs = [];
    if (data.fase === 'knockout') for (let i = 0; i < vivos.length; i += 2) currentPairs.push([vivos[i], vivos[i + 1]]);

    const seeds = data.ko_seeds || [];

    // Resuelve los cruces de una ronda: jugados (con resultado), en curso (vs), o todavía
    // por definir, en cuyo caso se infieren a partir de los ganadores (posibles o ya
    // decididos) de la ronda anterior.
    const pairsCache = {};
    const getPairs = (ronda) => {
        if (pairsCache[ronda]) return pairsCache[ronda];
        let pairs;
        const decided = decididas[ronda];
        if (decided && decided.length) {
            pairs = decided.map((t) => ({ a: t.home_tm_id, b: t.away_tm_id, score: `${t.global_home}-${t.global_away}${t.penales ? ' p' : ''}`, winner: t.ganador_tm_id }));
        } else if (ronda === data.ko_ronda && currentPairs.length) {
            pairs = currentPairs.map((p) => ({ a: p[0], b: p[1], score: null, winner: null }));
        } else if (ronda === 'octavos') {
            const prev = getPairs('16avos');
            pairs = seeds.map((seedId, i) => ({ a: seedId, b: prev[i] ? prev[i].winner : null, score: null, winner: null }));
        } else if (ronda !== '16avos') {
            const prev = getPairs(KO_ORDER[KO_ORDER.indexOf(ronda) - 1]);
            const n = KO_PAIR_COUNT[ronda];
            pairs = [];
            for (let i = 0; i < n; i++) {
                pairs.push({ a: prev[2 * i] ? prev[2 * i].winner : null, b: prev[2 * i + 1] ? prev[2 * i + 1].winner : null, score: null, winner: null });
            }
        } else {
            pairs = Array.from({ length: KO_PAIR_COUNT['16avos'] }, () => ({ a: null, b: null, score: null, winner: null }));
        }
        pairsCache[ronda] = pairs;
        return pairs;
    };

    // La Libertadores arranca directamente en octavos (no tiene 16avos): se recorta el bracket.
    const startRonda = data.competicion === 'libertadores' ? 'octavos' : '16avos';
    const rounds = KO_ORDER.slice(KO_ORDER.indexOf(startRonda));
    const secciones = rounds.map((ronda) => ({ ronda, rows: getPairs(ronda) }));

    const teamCell = (id, { winner, faded, right } = {}) => {
        const c = id ? clubById.get(id) : null;
        return (
            <td className={`cs-table-club${right ? ' cs-bk-cell-right' : ''}`}>
                <span className={`cs-table-club-inner${right ? ' cs-bk-inner-right' : ''}${winner ? ' cs-bk-win' : ''}${faded ? ' cs-bk-faded' : ''}${!id ? ' cs-bk-tbd' : ''}${id === careerTmId ? ' cs-bk-me' : ''}`}>
                    {id && <ClubCrest logo={c ? c.logo : ''} nombre={c ? c.nombre : ''} />}
                    <span>{c ? c.nombre : 'A definir'}</span>
                </span>
            </td>
        );
    };

    return (
        <div className="cs-bracket">
            {secciones.map((sec) => (
                <div className="cs-bk-round" key={sec.ronda}>
                    <div className="cs-bk-round-title">{KO_RONDA_LABEL[sec.ronda]}</div>
                    <table className="cs-table cs-bk-table">
                        <tbody>
                            {sec.rows.map((t, i) => {
                                const hasWinner = !!t.winner;
                                return (
                                    <tr className="cs-table-row" key={i}>
                                        {teamCell(t.a, { winner: hasWinner && t.winner === t.a, faded: hasWinner && t.winner !== t.a })}
                                        <td className="cs-bk-score">{t.score || 'vs'}</td>
                                        {teamCell(t.b, { winner: hasWinner && t.winner === t.b, faded: hasWinner && t.winner !== t.b, right: true })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
}

// Bracket de selección (Mundial / repechaje), con el mismo estilo que el de Champions pero con
// colores del Mundial (.cs-bracket--mundial). `rondas` = [{ titulo, partidos: [{a,b,gh,ga,ganador,
// penales}] }] donde a/b/ganador son códigos de país.
function BracketSel({ rondas, paisJ }) {
    const cell = (pais, { winner, faded, right } = {}) => {
        const nom = pais ? (SELECCIONES_BY_PAIS[pais]?.nombre || pais) : 'A definir';
        return (
            <td className={`cs-table-club${right ? ' cs-bk-cell-right' : ''}`}>
                <span className={`cs-table-club-inner${right ? ' cs-bk-inner-right' : ''}${winner ? ' cs-bk-win' : ''}${faded ? ' cs-bk-faded' : ''}${!pais ? ' cs-bk-tbd' : ''}${pais && pais === paisJ ? ' cs-bk-me' : ''}`}>
                    {pais && getFlagUrl(pais) && <img className="cs-flag" src={getFlagUrl(pais)} alt="" />}
                    <span>{nom}</span>
                </span>
            </td>
        );
    };
    return (
        <div className="cs-bracket cs-bracket--mundial">
            {rondas.map((sec, si) => (
                <div className="cs-bk-round" key={si}>
                    <div className="cs-bk-round-title">{sec.titulo}</div>
                    <table className="cs-table cs-bk-table">
                        <tbody>
                            {sec.partidos.map((p, i) => {
                                const hasW = !!p.ganador;
                                return (
                                    <tr className="cs-table-row" key={i}>
                                        {cell(p.a, { winner: hasW && p.ganador === p.a, faded: hasW && p.ganador !== p.a })}
                                        <td className="cs-bk-score">{p.gh != null ? `${p.gh}-${p.ga}${p.penales ? ' p' : ''}` : 'vs'}</td>
                                        {cell(p.b, { winner: hasW && p.ganador === p.b, faded: hasW && p.ganador !== p.b, right: true })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
}

// Construye el CUADRO COMPLETO de eliminación del Mundial (todas las rondas), estilo Champions:
// se muestran octavos/cuartos/semis/final con los espacios en blanco que se van completando a
// medida que ganan los equipos. `koRondas` = rondas ya jugadas; `koVivos` = equipos vivos en orden
// de bracket (para dibujar los 16avos antes de jugarse).
const KO_ORDER_FULL = ['16avos', 'octavos', 'cuartos', 'semis', 'final'];
const KO_SIZE = { '16avos': 16, octavos: 8, cuartos: 4, semis: 2, final: 1 };
function buildFullKOBracket(koRondas, koVivos) {
    const byRound = {};
    for (const r of (koRondas || [])) byRound[r.ronda] = r.partidos;
    const rounds = [];
    let prevWinners = null;
    for (const ronda of KO_ORDER_FULL) {
        const size = KO_SIZE[ronda];
        const played = byRound[ronda];
        let partidos;
        if (played) {
            partidos = played.map((p) => ({ a: p.a, b: p.b, gh: p.gh, ga: p.ga, penales: p.penales, ganador: p.ganador }));
            prevWinners = played.map((p) => p.ganador);
        } else {
            let teams = prevWinners;
            if (ronda === '16avos' && !teams && koVivos && koVivos.length) teams = koVivos;
            partidos = [];
            for (let i = 0; i < size; i++) {
                partidos.push({
                    a: teams ? (teams[2 * i] ?? null) : null,
                    b: teams ? (teams[2 * i + 1] ?? null) : null,
                    gh: null, ga: null, ganador: null,
                });
            }
            prevWinners = null;
        }
        rounds.push({ titulo: KO_RONDA_LABEL[ronda] || ronda, partidos });
    }
    return rounds;
}

// Fase de grupos de las copas sudamericanas: 8 mini-tablas con zonas de clasificación.
// Libertadores: 1º-2º clasifican a octavos, 3º baja a Sudamericana.
// Sudamericana: 1º clasifica a octavos, 2º juega 16avos.
function ConmebolGroups({ data, careerTmId }) {
    const grupos = data.grupos || [];
    // El grupo del club del jugador va primero y se destaca con un borde iluminado,
    // sin importar la letra de grupo que le tocó.
    const ordenados = [...grupos].sort((a, b) => {
        const aMio = a.tabla.some(c => c.tm_id === careerTmId) ? 0 : 1;
        const bMio = b.tabla.some(c => c.tm_id === careerTmId) ? 0 : 1;
        if (aMio !== bMio) return aMio - bMio;
        return a.grupo - b.grupo;
    });
    const esLibertadores = data.competicion === 'libertadores';
    const zoneFor = (pos) => {
        if (esLibertadores) {
            if (pos <= 2) return 'octavos';
            if (pos === 3) return 'dieciseisavos'; // baja a Sudamericana
            return 'eliminado';
        }
        if (pos === 1) return 'octavos';
        if (pos === 2) return 'dieciseisavos';
        return 'eliminado';
    };
    return (
        <>
            <div className="cs-conmebol-groups">
                {ordenados.map(({ grupo, tabla }) => {
                    const esMiGrupo = tabla.some(c => c.tm_id === careerTmId);
                    return (
                    <div className={`cs-conmebol-group${esMiGrupo ? ' cs-conmebol-group--mio' : ''}`} key={grupo}>
                        <div className="cs-conmebol-group-title">Grupo {String.fromCharCode(65 + grupo)}</div>
                        <table className="cs-table cs-conmebol-table">
                            <thead>
                                <tr><th>#</th><th className="cs-table-club">Club</th><th>PJ</th><th>DG</th><th>Pts</th></tr>
                            </thead>
                            <tbody>
                                {tabla.map((club, idx) => {
                                    const pos = idx + 1;
                                    const zone = zoneFor(pos);
                                    const isCurrent = club.tm_id === careerTmId;
                                    return (
                                        <tr key={`${club.tm_id || club.nombre}-${idx}`}
                                            className={`cs-table-row cs-table-row--${zone}${isCurrent ? ' cs-table-row--current' : ''}`}>
                                            <td><span className={`cs-pos-badge cs-pos-badge--${zone}`}>{pos}</span></td>
                                            <td className="cs-table-club">
                                                <span className="cs-table-club-inner">
                                                    <ClubCrest logo={club.logo} nombre={club.nombre} />
                                                    <span>{club.nombre}</span>
                                                </span>
                                            </td>
                                            <td>{club.pj}</td>
                                            <td>{club.gf - club.gc}</td>
                                            <td>{club.pts}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    );
                })}
            </div>
            <div className="cs-table-legend">
                <span><i className="cs-dot cs-dot--octavos" /> {esLibertadores ? 'Octavos (1º y 2º)' : 'Octavos (1º)'}</span>
                <span><i className="cs-dot cs-dot--dieciseisavos" /> {esLibertadores ? '3º → Sudamericana' : '16avos (2º)'}</span>
            </div>
        </>
    );
}

function CareerSimulatorPage2() {
    const [step, setStep] = useState('loading'); // loading | crear_personaje | elegir_club | dashboard
    const [career, setCareer] = useState(null);
    const [clubOptions, setClubOptions] = useState([]);
    const [loadingAction, setLoadingAction] = useState(false);
    const [standings, setStandings] = useState(null);
    const [nextMatch, setNextMatch] = useState(null);
    const [nextEuro, setNextEuro] = useState(null);
    const [temporadaFinalizada, setTemporadaFinalizada] = useState(false);
    // Panel de atributos: borrador (draft) sobre el que se asignan puntos antes de guardar.
    const [showAtributosModal, setShowAtributosModal] = useState(false);
    const [atrDraft, setAtrDraft] = useState(null); // { atributos, puntos, base }
    // Eventos entre partidos (decisiones) + resultado de la última decisión.
    const [eventoPendiente, setEventoPendiente] = useState(null);
    const [eventoResultado, setEventoResultado] = useState(null);
    const [seasonSummary, setSeasonSummary] = useState(null);
    const [showSeasonModal, setShowSeasonModal] = useState(false);
    const [euroStandings, setEuroStandings] = useState({ champions: null, europa: null, libertadores: null, sudamericana: null });
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [decidingTransfer, setDecidingTransfer] = useState(false);
    // Cajón de tablas (solo móvil): muestra liga + copa sobre el partido.
    // En móvil se alterna entre el panel del equipo (estado/tácticas/resultados) y las tablas.
    const [mobileTab, setMobileTab] = useState('estado'); // 'estado' | 'tablas'
    const [mobileTablaSel, setMobileTablaSel] = useState(null); // cuál tabla mostrar en mobile (liga/copa/seleccion)

    const [simSpeed, setSimSpeed] = useState(() => {
        try {
            return localStorage.getItem(SIM_SPEED_KEY) || 'rapido';
        } catch {
            return 'rapido';
        }
    });
    const [showLiveMatchModal, setShowLiveMatchModal] = useState(false);
    const [liveMatch, setLiveMatch] = useState(null);
    const [pendingAdvanceResult, setPendingAdvanceResult] = useState(null);
    const [goalFlash, setGoalFlash] = useState(null);
    const [autoMode, setAutoMode] = useState(false);
    const [showRetireModal, setShowRetireModal] = useState(false);
    const [showTacticasModal, setShowTacticasModal] = useState(false);
    const [forcedRetire, setForcedRetire] = useState(false);

    // ── LOGROS (achievements) globales del usuario ──
    const [showLogrosModal, setShowLogrosModal] = useState(false);
    const [showSeleccionModal, setShowSeleccionModal] = useState(false);
    const [mundialCallup, setMundialCallup] = useState(null); // { pais } cuando te convocan al Mundial
    const [logrosData, setLogrosData] = useState(null); // { catalog, unlocked, acc }
    const knownLogrosRef = useRef(new Set());            // keys ya desbloqueadas (para no spamear sync)
    const syncedPaisRef = useRef(new Set());             // eventos de país ya enviados esta sesión
    const [showNationalityModal, setShowNationalityModal] = useState(false);
    const [sharing, setSharing] = useState(false);

    const [showAdminClubPicker, setShowAdminClubPicker] = useState(false);
    const [adminClubSearch, setAdminClubSearch] = useState('');
    const [adminClubLoading, setAdminClubLoading] = useState(false);

    const { user, isUserLoading } = useAuth();
    // El user del AuthContext no trae isAdmin (se excluye del documento por seguridad);
    // hay que decodificarlo del JWT, como hace AdminRoute.
    const isAdmin = (() => {
        if (!user?.token) return false;
        try {
            return !!jwtDecode(user.token).isAdmin;
        } catch {
            return false;
        }
    })();

    const [form, setForm] = useState({ nombre: '', nacionalidad: '', posicion: POSITIONS[0], altura: FISICO_DEFAULT.altura, peso: FISICO_DEFAULT.peso, atributos: PM.atributosVacios(), avatar: { ...AVATAR_DEFAULT } });

    const setAvatar = (patch) => setForm((f) => ({ ...f, avatar: { ...f.avatar, ...patch } }));
    // Sección activa del creador (para no tener una página tan larga): datos | cabeza | cuerpo.
    const [creatorSection, setCreatorSection] = useState('datos');

    // Carga del juego una vez que sabemos si el usuario está logueado. Si NO lo está, no le pegamos
    // al backend (daría 401): mostramos un cartel pidiendo iniciar sesión (no un error técnico).
    const didLoadRef = useRef(false);
    useEffect(() => {
        if (isUserLoading || didLoadRef.current) return;
        didLoadRef.current = true;
        if (!user) { setStep('no_auth'); return; }
        // Aplicar overrides de selecciones (admin) ANTES de cargar la carrera, para que los
        // próximos sorteos usen las valoraciones/ranking tuneados.
        getSeleccionesConfig()
            .then((d) => { aplicarOverridesSelecciones(d?.overrides); })
            .catch(() => {})
            .finally(() => loadCareer());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserLoading, user]);

    // Modo mantenimiento: sólo decide si se muestra el cartel a los NO-admins (overlay). No
    // bloquea la carga del juego. Default false (fail-open).
    const [maintenance, setMaintenance] = useState(false);

    useEffect(() => {
        let cancel = false;
        getCareerMaintenance()
            .then((d) => { if (!cancel) setMaintenance(!!d?.maintenance); })
            .catch(() => { /* si falla, no bloqueamos */ });
        return () => { cancel = true; };
    }, []);

    useEffect(() => {
        try {
            localStorage.setItem(SIM_SPEED_KEY, simSpeed);
        } catch {
            // localStorage no disponible, no pasa nada
        }
    }, [simSpeed]);

    // Animación minuto a minuto del partido en vivo (modo lento).
    useEffect(() => {
        if (!showLiveMatchModal || !liveMatch || liveMatch.finished) return undefined;
        const timer = setTimeout(() => {
            setLiveMatch((lm) => {
                if (!lm) return lm;
                const nextMinute = lm.currentMinute + 1;
                let homeScore = lm.homeScore;
                let awayScore = lm.awayScore;
                for (const ev of lm.events) {
                    if (ev.minute === nextMinute) {
                        if (ev.team === 'home') homeScore++; else awayScore++;
                    }
                }
                return {
                    ...lm,
                    currentMinute: nextMinute,
                    homeScore,
                    awayScore,
                    finished: nextMinute >= 90,
                };
            });
        }, 60);
        return () => clearTimeout(timer);
    }, [showLiveMatchModal, liveMatch]);

    // Animación de la tanda de penales: se revela un penal cada ~750ms cuando termina el tiempo regular.
    useEffect(() => {
        if (!showLiveMatchModal || !liveMatch || !liveMatch.finished || !liveMatch.penales) return undefined;
        if (liveMatch.penalStep >= liveMatch.penales.tanda.length) return undefined;
        const t = setTimeout(() => {
            setLiveMatch((lm) => (lm ? { ...lm, penalStep: (lm.penalStep || 0) + 1 } : lm));
        }, 750);
        return () => clearTimeout(t);
    }, [showLiveMatchModal, liveMatch]);

    // Cartel de "¡GOL!" temporal cuando se llega al minuto del evento.
    useEffect(() => {
        if (!liveMatch) return undefined;
        const goal = liveMatch.events.find((e) => e.minute === liveMatch.currentMinute);
        if (!goal) return undefined;
        const equipoGol = goal.team === 'home' ? liveMatch.homeNombre : liveMatch.awayNombre;
        let text;
        if (goal.tipo === 'gol') text = `⚽ ¡GOL TUYO! (${goal.minute}')`;
        else if (goal.tipo === 'asistencia') text = `🅰️ ¡Asistencia tuya! (${goal.minute}')`;
        else text = `⚽ Gol de ${equipoGol} (${goal.minute}')`;
        setGoalFlash(text);
        const t = setTimeout(() => setGoalFlash(null), 1800);
        return () => clearTimeout(t);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [liveMatch?.currentMinute]);

    const loadCareer = async () => {
        try {
            const { career } = await getMyCareer();
            if (!career) {
                setCareer(null);
                setStep('crear_personaje');
                return;
            }
            setCareer(career);
            // Logros: traer estado global y evaluar la carrera cargada (por si quedó algo sin marcar).
            refreshLogros();
            checkLogros(career, {});
            if (career.fase === 'eligiendo_club') {
                await loadClubOptions();
                setStep('elegir_club');
            } else {
                await loadDashboardData(career);
                setStep('dashboard');
                // Si hay una oferta de traspaso pendiente, hay que decidirla SÍ O SÍ antes de
                // seguir jugando: la reabrimos al cargar (no se puede esquivar refrescando).
                if (career.ofertas_transferencia?.length > 0) {
                    setShowTransferModal(true);
                }
            }
        } catch (err) {
            toast.error('Error al cargar tu partida.');
            setStep('crear_personaje');
        }
    };

    const loadClubOptions = async () => {
        try {
            const { clubOptions } = await getCareerClubOptions();
            setClubOptions(clubOptions || []);
        } catch (err) {
            toast.error('Error al obtener opciones de club.');
        }
    };

    // Ordena una tabla por puntos, diferencia de gol y goles a favor (misma lógica que el backend).
    const sortTabla = (clubs) => [...clubs].sort((a, b) => {
        if (b.pts !== a.pts) return b.pts - a.pts;
        const dgA = a.gf - a.gc;
        const dgB = b.gf - b.gc;
        if (dgB !== dgA) return dgB - dgA;
        return b.gf - a.gf;
    });

    // El documento de carrera ya trae las ligas completas (clubes + calendario):
    // calculamos todo localmente en vez de pegarle 4 veces más a la API por jornada.
    const loadDashboardData = async (currentCareer) => {
        const myTmId = currentCareer.club_actual?.tm_id;
        const league = currentCareer.leagues?.find(
            (l) => l.pais === currentCareer.club_actual?.pais && l.division === currentCareer.club_actual?.division
        );
        if (!league) return;

        setStandings({
            nombre: league.nombre,
            pais: league.pais,
            division: league.division,
            cupos_champions: league.cupos_champions,
            cupos_europa: league.cupos_europa,
            cupos_libertadores: league.cupos_libertadores,
            cupos_sudamericana: league.cupos_sudamericana,
            ascensos: league.ascensos,
            descensos: league.descensos,
            tabla: sortTabla(league.clubs),
        });

        const clubByTmId = new Map(league.clubs.map((c) => [c.tm_id, c]));
        let proximo = null;
        for (const j of league.calendario) {
            const partido = j.partidos.find(
                (p) => !p.jugado && (p.home_tm_id === myTmId || p.away_tm_id === myTmId)
            );
            if (partido) {
                proximo = {
                    jornada: j.jornada,
                    home: partido.home_tm_id ? clubByTmId.get(partido.home_tm_id) || null : null,
                    away: partido.away_tm_id ? clubByTmId.get(partido.away_tm_id) || null : null,
                    gh: partido.gh,
                    ga: partido.ga,
                    jugado: partido.jugado,
                    esLocal: partido.home_tm_id === myTmId,
                };
                break;
            }
        }
        setNextMatch(proximo);

        // Próximo partido europeo, para que no aparezca "de sorpresa" junto al de liga.
        let proximoEuro = null;
        for (const [comp, nombre, competicion] of [
            [currentCareer.champions_league, 'Champions League', 'champions'],
            [currentCareer.europa_league, 'Europa League', 'europa'],
            [currentCareer.libertadores, 'Copa Libertadores', 'libertadores'],
            [currentCareer.sudamericana, 'Copa Sudamericana', 'sudamericana'],
        ]) {
            if (!comp?.clubs?.some((c) => c.tm_id === myTmId)) continue;
            const esConmebol = competicion === 'libertadores' || competicion === 'sudamericana';
            const euroClubById = new Map(comp.clubs.map((c) => [c.tm_id, c]));
            if (comp.fase === 'grupos') {
                for (const j of comp.calendario || []) {
                    const partido = j.partidos.find((p) => !p.jugado && (p.home_tm_id === myTmId || p.away_tm_id === myTmId));
                    if (partido) {
                        const esLocal = partido.home_tm_id === myTmId;
                        const rivalId = esLocal ? partido.away_tm_id : partido.home_tm_id;
                        const faseTxt = `${esConmebol ? 'Fase de grupos' : 'Fase de liga'} · J${j.jornada}`;
                        // Misma key que usa el motor para el esquema del rival (careerTurn: `<comp><temp>-g<ronda>-<tmId>`).
                        const scoutKey = `${competicion}${currentCareer.temporada}-g${j.jornada}-${rivalId}`;
                        proximoEuro = { competicion, nombre, faseTxt, esLocal, rival: euroClubById.get(rivalId) || null, knockout: false, scoutKey };
                        break;
                    }
                }
            } else if (comp.fase === 'knockout') {
                const vivos = comp.ko_vivos || [];
                const idx = vivos.indexOf(myTmId);
                if (idx >= 0) {
                    const rivalId = vivos[idx % 2 === 0 ? idx + 1 : idx - 1];
                    const leg = (comp.ko_ida && comp.ko_ida.length) ? 'vuelta' : 'ida';
                    const soyA = idx % 2 === 0;
                    const esLocal = leg === 'ida' ? soyA : !soyA;
                    const legTxt = comp.ko_ronda === 'final' ? '' : leg === 'ida' ? ' (ida)' : ' (vuelta)';
                    // Parcial de la ida cuando vas a jugar la vuelta.
                    let idaResultado = null;
                    if (leg === 'vuelta') {
                        const ida = (comp.ko_ida || []).find((r) => r.home_tm_id === myTmId || r.away_tm_id === myTmId);
                        if (ida) {
                            const soyHomeIda = ida.home_tm_id === myTmId;
                            idaResultado = { favor: soyHomeIda ? ida.gh : ida.ga, contra: soyHomeIda ? ida.ga : ida.gh };
                        }
                    }
                    // Misma key que el motor para el KO (careerTurn: `<comp><temp>-k<ronda>-<leg>-<tmId>`).
                    const scoutKey = rivalId ? `${competicion}${currentCareer.temporada}-k${comp.ko_ronda}-${leg}-${rivalId}` : null;
                    proximoEuro = { competicion, nombre, faseTxt: `${KO_RONDA_LABEL[comp.ko_ronda] || comp.ko_ronda}${legTxt}`, esLocal, rival: rivalId ? euroClubById.get(rivalId) || null : null, knockout: true, idaResultado, scoutKey };
                }
            }
            if (proximoEuro) break;
        }
        setNextEuro(proximoEuro);

        const buildEuro = (comp, nombre, competicion) => {
            if (!comp?.clubs?.some((c) => c.tm_id === myTmId)) return null;
            const esConmebol = competicion === 'libertadores' || competicion === 'sudamericana';
            const vivo = comp.fase === 'knockout'
                && (comp.ko_vivos?.includes(myTmId) || (comp.ko_ronda === '16avos' && comp.ko_seeds?.includes(myTmId)));
            // Para las copas por grupos, armar las 8 tablas de grupo (solo clubes con grupo >= 0).
            let grupos = null;
            if (esConmebol) {
                const byGroup = new Map();
                for (const c of comp.clubs) {
                    if (c.grupo == null || c.grupo < 0) continue;
                    if (!byGroup.has(c.grupo)) byGroup.set(c.grupo, []);
                    byGroup.get(c.grupo).push(c);
                }
                grupos = [...byGroup.keys()].sort((a, b) => a - b)
                    .map((g) => ({ grupo: g, tabla: sortTabla(byGroup.get(g)) }));
            }
            return {
                nombre, competicion,
                formato: esConmebol ? 'grupos' : 'liga',
                grupos,
                tabla: sortTabla(comp.clubs),
                clubs: comp.clubs,
                fase: comp.fase,
                ko_ronda: comp.ko_ronda,
                ko_seeds: comp.ko_seeds || [],
                ko_vivos: comp.ko_vivos || [],
                ko_resultados: comp.ko_resultados || [],
                campeon_tm_id: comp.campeon_tm_id,
                es_campeon: comp.campeon_tm_id && comp.campeon_tm_id === myTmId,
                jugador_vivo: vivo,
            };
        };
        setEuroStandings({
            champions: buildEuro(currentCareer.champions_league, 'Champions League', 'champions'),
            europa: buildEuro(currentCareer.europa_league, 'Europa League', 'europa'),
            libertadores: buildEuro(currentCareer.libertadores, 'Copa Libertadores', 'libertadores'),
            sudamericana: buildEuro(currentCareer.sudamericana, 'Copa Sudamericana', 'sudamericana'),
        });
    };

    // ── Simulación en el navegador ──────────────────────────────────────────────
    // careerRef siempre apunta a la carrera más actual (para encadenar turnos en el modo
    // automático sin esperar al re-render de React).
    const careerRef = useRef(career);
    useEffect(() => { careerRef.current = career; }, [career]);

    const cloneCareer = (c) => JSON.parse(JSON.stringify(c));

    // ── Pizarra táctica y eventos ───────────────────────────────────────────────
    // Cambia un eje de la pizarra (formación / actitud / presión / estilo / marca).
    const cambiarTactica = (eje, valor) => {
        const c = careerRef.current;
        if (!c) return;
        c.tacticas = { ...defaultTacticas(), ...(c.tacticas || {}), [eje]: valor };
        careerRef.current = c;
        setCareer({ ...c });
        scheduleSave();
    };

    const matchesSinceEvento = useRef(0);
    const recientesEventos = useRef([]);

    // Tras un partido puede saltar un evento con decisión (en manual y en automático). Devuelve
    // true si disparó uno (el modo automático lo usa para frenar y que el usuario decida).
    const maybeTriggerEvento = (data) => {
        const c = careerRef.current;
        if (!c || c.fase !== 'en_curso') return false;
        if (data && (data.resumenTemporada || data.retirado || data.temporadaFinalizada)) return false;
        if (c.ofertas_transferencia?.length > 0) return false; // no pisar el modal de oferta
        matchesSinceEvento.current += 1;
        // Los eventos de vida del jugador ahora son sólo "color" esporádico: el mecanismo de
        // agencia principal es el plan de partido. Por eso baja mucho su frecuencia.
        if (matchesSinceEvento.current < 6) return false;
        if (Math.random() > 0.12) return false;
        matchesSinceEvento.current = 0;
        const evt = elegirEvento(recientesEventos.current);
        recientesEventos.current = [evt.id, ...recientesEventos.current].slice(0, 12);
        setEventoResultado(null);
        setEventoPendiente(evt);
        return true;
    };

    const resolverEvento = (opcion) => {
        const c = careerRef.current;
        if (!c || !eventoPendiente) return;
        // La opción tiene varios resultados posibles: se elige uno al azar (a veces te va bien,
        // a veces te quema) y muta la carrera (moral/atributos).
        const mensaje = resolverOpcion(c, opcion);
        careerRef.current = c;
        setCareer({ ...c });
        scheduleSave();
        setEventoResultado(mensaje);
    };

    // Avanza UN turno LOCALMENTE (instantáneo, sin red). Devuelve el mismo shape que devolvía
    // el endpoint del backend, para reusar applyAdvanceResult tal cual.
    const simulateOneTurnLocal = () => {
        const c = cloneCareer(careerRef.current);
        finalizeOtherLeagues(c);
        const result = runTurn(c);     // muta y devuelve c
        prunePlayedFixtures(c);
        careerRef.current = result.career; // encadenamos sincrónicamente para el loop automático
        // Logros: evaluamos tras cada turno (fire-and-forget; solo pega a la red si hay novedad).
        // result.retirado = retiro OBLIGATORIO por edad (39). Marcamos retiredByAge para el logro
        // imposible que solo cuenta si te retirás de viejo (no el retiro voluntario).
        checkLogros(result.career, { retired: !!result.retirado, retiredByAge: !!result.retirado });
        return result;
    };

    // ── LOGROS ──────────────────────────────────────────────────────────────────
    // Trae el estado global de logros del usuario (catálogo + desbloqueados).
    const refreshLogros = async () => {
        try {
            const d = await getAchievements();
            setLogrosData(d);
            knownLogrosRef.current = new Set((d.unlocked || []).map((u) => u.key));
        } catch { /* silencioso: los logros no deben romper la carrera */ }
    };

    // Evalúa la carrera y sincroniza con el backend SOLO si hay algo nuevo (un logro candidato no
    // conocido, o una copa CONMEBOL con un país nuevo). El backend guarda el primer desbloqueo.
    const checkLogros = async (career, ctx = {}) => {
        if (!career) return;
        let evalRes;
        try { evalRes = evaluarLogros(career, ctx); } catch { return; }
        const hayKeyNueva = evalRes.unlocked.some((u) => !knownLogrosRef.current.has(u.key));
        const hayPaisNuevo = evalRes.paisEvents.some((e) => !syncedPaisRef.current.has(`${e.tipo}|${e.pais}`));
        if (!hayKeyNueva && !hayPaisNuevo) return;
        for (const e of evalRes.paisEvents) syncedPaisRef.current.add(`${e.tipo}|${e.pais}`);
        try {
            const resp = await syncAchievements({ unlocked: evalRes.unlocked, paisEvents: evalRes.paisEvents });
            knownLogrosRef.current = new Set((resp.unlocked || []).map((u) => u.key));
            setLogrosData((d) => (d ? { ...d, unlocked: resp.unlocked, acc: resp.acc } : d));
            for (const key of (resp.newlyUnlocked || [])) {
                const def = LOGROS_BY_KEY[key];
                if (def) toast.success(`🏆 ¡Logro desbloqueado! ${def.titulo}`);
            }
        } catch { /* silencioso */ }
    };

    // ── Guardado en 2º plano (debounced) ────────────────────────────────────────
    const saveTimer = useRef(null);
    const savePending = useRef(false);
    const doSave = async () => {
        if (!savePending.current) return;
        savePending.current = false;
        try { await saveCareerState(careerRef.current); }
        catch { savePending.current = true; } // si falla, queda pendiente para el próximo intento
    };
    const scheduleSave = () => {
        savePending.current = true;
        if (saveTimer.current) clearTimeout(saveTimer.current);
        saveTimer.current = setTimeout(doSave, 1200);
    };
    const flushSave = async () => {
        if (saveTimer.current) { clearTimeout(saveTimer.current); saveTimer.current = null; }
        await doSave();
    };
    // Guarda SÍ O SÍ el estado actual (no depende de savePending) y propaga el error si falla.
    // Para acciones que el backend procesa sobre la carrera guardada (p. ej. fichar).
    const forceSave = async () => {
        if (saveTimer.current) { clearTimeout(saveTimer.current); saveTimer.current = null; }
        await saveCareerState(careerRef.current);
        savePending.current = false;
    };
    // Al desmontar, persistir lo pendiente (best-effort).
    useEffect(() => () => { if (savePending.current) doSave(); }, []);

    // ¿Hay una oferta de traspaso sin decidir? No se puede avanzar hasta resolverla (ni
    // refrescando: la oferta vive en la carrera guardada). Reabre el modal si se intenta.
    const bloqueadoPorOferta = () => {
        if (careerRef.current?.ofertas_transferencia?.length > 0) {
            setShowTransferModal(true);
            toast.info('Tenés que decidir la oferta de traspaso antes de seguir.');
            return true;
        }
        return false;
    };

    const handleAdvanceMatchday = async (speedOverride) => {
        if (bloqueadoPorOferta()) return;
        const speed = speedOverride || simSpeed;
        if (speedOverride) setSimSpeed(speedOverride);
        setLoadingAction(true);
        try {
            const data = simulateOneTurnLocal();
            const { career: updatedCareer, partidoJugador, partidoEuropeo, partidoSeleccion, esTurnoEuro, esTurnoSeleccion, resumenTemporada } = data;

            // En modo lento animamos el partido del jugador, sea de liga, copa o selección.
            // Los cierres sintéticos del Mundial (eliminado sin rival real) NO son partidos jugables:
            // no abrimos el modal en vivo para no "jugar contra nadie".
            const partidoSeleccionJugable = esTurnoSeleccion && partidoSeleccion && !partidoSeleccion.eliminado_mundial ? partidoSeleccion : null;
            const partidoParaVivo = partidoJugador || (esTurnoEuro ? partidoEuropeo : null) || partidoSeleccionJugable;
            if (speed === 'lento' && partidoParaVivo && !resumenTemporada) {
                const rivalLogo = esTurnoSeleccion
                    ? null // bandera del rival la usamos en lugar de logo (ver buildLiveMatch)
                    : esTurnoEuro
                        ? nextEuro?.rival?.logo
                        : standings?.tabla?.find((c) => c.nombre === partidoParaVivo.rival_nombre)?.logo;
                setPendingAdvanceResult(data);
                setLiveMatch(buildLiveMatch(partidoParaVivo, career, updatedCareer.jornada_actual, rivalLogo));
                setShowLiveMatchModal(true);
                return;
            }

            await applyAdvanceResult(data);
            maybeTriggerEvento(data);
        } catch (err) {
            toast.error('Error al avanzar la jornada.');
            setLoadingAction(false);
        }
    };

    const formatMatchLine = (p, prefijo = '') => {
        const { gf, gc, local, rival_nombre, minutos_jugados, goles_jugador, asistencias_jugador, amarilla, roja } = p;
        const resultado = gf > gc ? 'Ganaste' : gf < gc ? 'Perdiste' : 'Empataste';
        let extra = ` · ${minutos_jugados}'`;
        if (goles_jugador > 0) extra += ` · ⚽ ${goles_jugador}`;
        if (asistencias_jugador > 0) extra += ` · 🅰️ ${asistencias_jugador}`;
        if (amarilla) extra += ' · 🟨';
        if (roja) extra += ' · 🟥';
        return `${prefijo}${resultado} ${gf}-${gc} ${local ? 'vs' : '@'} ${rival_nombre}${extra}`;
    };

    const applyAdvanceResult = async (data, { skipPlayerToast = false } = {}) => {
        const { career: updatedCareer, partidoJugador, partidoEuropeo, partidoSeleccion, suspendido, temporadaFinalizada: finalizada, resumenTemporada, retirado, esEspectadorMundial, mundialEspectadorStep } = data;
        try {
            setCareer(updatedCareer);
            setTemporadaFinalizada(!!finalizada);

            // Espectador: no clasificaste, pero ves el Mundial avanzar paso a paso en el panel.
            if (esEspectadorMundial && mundialEspectadorStep) {
                const s = mundialEspectadorStep;
                const RL = { '16avos': '16avos', octavos: 'Octavos', cuartos: 'Cuartos', semis: 'Semifinal', final: 'Final' };
                if (s.tipo === 'grupos') {
                    toast.info(s.fin_grupos ? '🌍 Mundial: terminó la fase de grupos. Arrancan los 16avos.' : `🌍 Mundial: se jugó la fecha ${s.fecha}/3 de grupos.`);
                } else if (s.tipo === 'ko') {
                    if (s.fin) {
                        const camp = SELECCIONES_BY_PAIS[s.campeon]?.nombre || s.campeon || '—';
                        toast.success(`🌍 ¡Mundial terminado! Campeón: ${camp}.`);
                    } else {
                        toast.info(`🌍 Mundial: se jugaron los ${RL[s.ronda] || s.ronda}.`);
                    }
                }
                return;
            }

            // Eliminado del Mundial pero el torneo sigue: avanzamos una ronda por turno (espectador).
            if (data.esMundialEliminadoEspectador && data.mundialEliminadoStep) {
                const s = data.mundialEliminadoStep;
                const RL = { '16avos': '16avos', octavos: 'Octavos', cuartos: 'Cuartos', semis: 'Semifinal', final: 'Final' };
                if (s.fin) {
                    const camp = SELECCIONES_BY_PAIS[s.campeon]?.nombre || s.campeon || '—';
                    toast.success(`🌍 ¡Mundial terminado! Campeón: ${camp}.`);
                } else {
                    toast.info(`🌍 Mundial: se jugaron los ${RL[s.ronda] || s.ronda}. Mirá cómo sigue el cuadro.`);
                }
                return;
            }

            // Clasificaste a la fase final: presentación del rival de 16avos ANTES de jugarlo.
            if (data.esMundialKOIntro) {
                const RL = { '16avos': '16avos', octavos: 'Octavos', cuartos: 'Cuartos', semis: 'Semifinal', final: 'Final' };
                const riv = SELECCIONES_BY_PAIS[data.rivalPais]?.nombre || data.rivalNombre || '—';
                toast.success(`🌍 ¡Pasaste de fase! ${RL[data.koRonda] || data.koRonda}: tu rival es ${riv}.`);
                return;
            }

            // 🎉 Turno de PRESENTACIÓN del Mundial (antes de jugar): convocatoria + se arma el cuadro.
            if (data.esMundialIntro) {
                if (data.convocadoMundial) {
                    setMundialCallup({ pais: data.paisMundial || updatedCareer.nacionalidad, ciclo: data.ciclo });
                } else {
                    toast.info('🌍 Empieza el Mundial. El DT no te consideró apto para esta convocatoria: tu selección juega sin vos. Podés seguirlo en el panel.');
                }
                return;
            }

            // Retiro obligatorio por edad (39 años): abrimos directo la pantalla de trayectoria.
            if (retirado) {
                await loadDashboardData(updatedCareer);
                setAutoMode(false);
                setForcedRetire(true);
                setShowRetireModal(true);
                return;
            }

            if (resumenTemporada) {
                setSeasonSummary(resumenTemporada);
                setShowSeasonModal(true);
                toast.info('¡Temporada finalizada!');
            } else if (finalizada) {
                toast.info('Temporada finalizada.');
            } else {
                const lines = [];
                if (suspendido && !skipPlayerToast) lines.push('🟥 Suspendido por roja: te perdés esta jornada de liga.');
                if (partidoJugador && !skipPlayerToast) {
                    lines.push(formatMatchLine(partidoJugador));
                    // Feedback del plan de partido: si te vino bien o mal contra ese rival.
                    if (partidoJugador.plan_feedback) lines.push(partidoJugador.plan_feedback);
                }
                if (partidoSeleccion) {
                    const comp = partidoSeleccion.competicion;
                    let ronda;
                    if (comp === 'clasificatoria') ronda = `Eliminatorias · Año ${partidoSeleccion.año_ciclo}/3`;
                    else if (comp === 'preplayoff') ronda = `Pre-repechaje CONCACAF`;
                    else if (comp === 'playoff') ronda = `Repechaje${partidoSeleccion.leg === 'ida' ? ' (ida)' : partidoSeleccion.leg === 'vuelta' ? ' (vuelta)' : ''}`;
                    else if (comp === 'mundial-grupo') ronda = `Mundial · Fecha ${partidoSeleccion.fecha}`;
                    else if (comp === 'mundial-ko') ronda = `Mundial · ${partidoSeleccion.ronda || 'KO'}`;
                    else ronda = 'Selección';
                    if (partidoSeleccion.eliminado_mundial) {
                        // partido placeholder de cierre (sin rival): no mostrar línea de partido.
                    } else if (partidoSeleccion.no_convocado) {
                        lines.push(`🌍 ${ronda}: 🚫 No convocado — tu selección jugó sin vos ${partidoSeleccion.gf}-${partidoSeleccion.gc} ${partidoSeleccion.local ? 'vs' : '@'} ${partidoSeleccion.rival_nombre}`);
                    } else {
                        lines.push(formatMatchLine(partidoSeleccion, `🌍 ${ronda}: `));
                    }
                    // Resoluciones especiales.
                    if (comp === 'preplayoff' && partidoSeleccion.resuelto === 'a_grupos') lines.push('   ✅ ¡A la fase de grupos!');
                    if (comp === 'preplayoff' && partidoSeleccion.resuelto === 'eliminado') lines.push('   ❌ Eliminado en el pre-repechaje');
                    if (comp === 'playoff' && partidoSeleccion.resuelto === 'clasificado') lines.push('   ✅ ¡Clasificado al Mundial!');
                    if (comp === 'playoff' && partidoSeleccion.resuelto === 'eliminado') lines.push('   ❌ Quedaste afuera del Mundial');
                    if (comp === 'mundial-ko' && partidoSeleccion.campeon) lines.push('   🏆 ¡CAMPEÓN DEL MUNDO!');
                    else if (comp === 'mundial-ko' && partidoSeleccion.avanzo) lines.push('   ✅ A la próxima ronda');
                    else if (comp === 'mundial-ko' && !partidoSeleccion.avanzo && !partidoSeleccion.eliminado_mundial) lines.push('   ❌ Eliminado del Mundial');
                }
                if (partidoEuropeo) {
                    const COPA_NOMBRE = { champions: 'Champions', europa: 'Europa', libertadores: 'Libertadores', sudamericana: 'Sudamericana' };
                    const copa = `${copaIcon(partidoEuropeo.competicion)} ${COPA_NOMBRE[partidoEuropeo.competicion] || 'Copa'}`;
                    let fase = '';
                    if (partidoEuropeo.fase === 'knockout') {
                        const r = KO_RONDA_LABEL[partidoEuropeo.ronda] || partidoEuropeo.ronda;
                        const legTxt = partidoEuropeo.leg === 'ida' ? ' (ida)' : partidoEuropeo.leg === 'vuelta' ? ' (vuelta)' : '';
                        fase = ` · ${r}${legTxt}`;
                    }
                    if (partidoEuropeo.suspendido) {
                        lines.push(`${copa}${fase}: 🟥 Suspendido — tu equipo jugó sin vos ${partidoEuropeo.gf}-${partidoEuropeo.gc} ${partidoEuropeo.local ? 'vs' : '@'} ${partidoEuropeo.rival_nombre}`);
                    } else {
                        lines.push(formatMatchLine(partidoEuropeo, `${copa}${fase}: `));
                    }
                    if (!partidoEuropeo.suspendido && partidoEuropeo.fase === 'knockout' && partidoEuropeo.leg !== 'ida') {
                        lines.push(`   Global ${partidoEuropeo.global_favor}-${partidoEuropeo.global_contra}${partidoEuropeo.penales ? ` · Penales ${partidoEuropeo.penal_favor}-${partidoEuropeo.penal_contra}` : ''}`);
                        lines.push(partidoEuropeo.avanzo
                            ? (partidoEuropeo.ronda === 'final' ? '   🏆 ¡CAMPEÓN!' : '   ✅ Clasificado a la próxima ronda')
                            : '   ❌ Eliminado de la competición');
                    }
                }
                if (lines.length > 0) {
                    // Color del toast según el resultado: victoria/clasificación = verde,
                    // empate = amarillo, derrota/eliminación/suspensión = rojo.
                    let tipo = 'success';
                    if (partidoEuropeo && partidoEuropeo.fase === 'knockout' && partidoEuropeo.leg !== 'ida') {
                        tipo = partidoEuropeo.avanzo ? 'success' : 'error';
                    } else if (partidoSeleccion) {
                        // Partido de selección: color por resultado / desenlace.
                        if (partidoSeleccion.eliminado_mundial || partidoSeleccion.resuelto === 'eliminado') tipo = 'error';
                        else if (partidoSeleccion.competicion === 'mundial-ko') tipo = (partidoSeleccion.campeon || partidoSeleccion.avanzo) ? 'success' : 'error';
                        else if (partidoSeleccion.resuelto === 'clasificado' || partidoSeleccion.resuelto === 'a_grupos') tipo = 'success';
                        else tipo = partidoSeleccion.gf > partidoSeleccion.gc ? 'success' : partidoSeleccion.gf < partidoSeleccion.gc ? 'error' : 'warning';
                    } else {
                        const principal = partidoEuropeo || partidoJugador;
                        if (principal) {
                            tipo = principal.gf > principal.gc ? 'success' : principal.gf < principal.gc ? 'error' : 'warning';
                        }
                        if (!partidoJugador && suspendido) tipo = 'error';
                    }
                    toast[tipo](
                        <div>
                            {lines.map((l, i) => <div key={i}>{l}</div>)}
                        </div>
                    );
                } else if (!partidoJugador && !suspendido && !skipPlayerToast) {
                    toast.info('Tu equipo descansó esta jornada.');
                }
            }

            await loadDashboardData(updatedCareer);

            if (!resumenTemporada && updatedCareer.ofertas_transferencia?.length > 0) {
                setShowTransferModal(true);
            }
            // La simulación corrió local: persistimos el resultado en 2º plano (debounced).
            careerRef.current = updatedCareer;
            scheduleSave();
        } finally {
            setLoadingAction(false);
        }
    };

    const handleLiveMatchClose = async () => {
        setShowLiveMatchModal(false);
        setLiveMatch(null);
        setGoalFlash(null);
        if (pendingAdvanceResult) {
            const data = pendingAdvanceResult;
            setPendingAdvanceResult(null);
            // El resultado ya se vio en vivo: no repetir el toast del partido de liga.
            await applyAdvanceResult(data, { skipPlayerToast: true });
            maybeTriggerEvento(data);
        }
    };

    // ¿El PRÓXIMO avance es un partido de eliminatoria de copa del jugador? El modo automático
    // se detiene antes de jugarlo para que el usuario lo dispute a mano (con animación y penales).
    const nextTurnIsEuroKnockout = (c) => {
        if (!c?.proximo_turno_es_euro) return false;
        const myTmId = c.club_actual?.tm_id;
        for (const comp of [c.champions_league, c.europa_league, c.libertadores, c.sudamericana]) {
            if (!comp?.clubs?.some((x) => x.tm_id === myTmId)) continue;
            if (comp.fase === 'knockout' && (comp.ko_vivos || []).includes(myTmId)) return true;
        }
        return false;
    };

    // Próximo partido de selección (clasif / repechaje / Mundial) o null. Lo usa el automático
    // (para frenar) y el dashboard (para mostrar el partido de selección y pintar distinto).
    const getSeleccionNext = (c) => {
        if (!c?.club_actual) return null;
        const league = c.leagues?.find((l) => l.pais === c.club_actual.pais && l.division === c.club_actual.division);
        if (!league) return null;
        try { return computeSeleccionNext(c, roundsForCount(league.clubs.length)); } catch { return null; }
    };

    // Pista de scouting del PRÓXIMO rival REAL del jugador. Antes mostraba siempre al rival de
    // liga, aunque el próximo partido fuese por otra competición (Champions, etc.). Ahora respeta
    // qué se juega de verdad: selección (sin pista de club), copa europea, o liga. Usa la MISMA key
    // que el motor para que el esquema mostrado coincida con el que el rival realmente jugará.
    const proximoScouting = () => {
        if (!career) return null;
        if (getSeleccionNext(career)) return null; // el próximo es de selección: no hay pista de club
        if (career.proximo_turno_es_euro && nextEuro?.rival && nextEuro.scoutKey) {
            const r = nextEuro.rival;
            return { pista: scoutingHint(rivalTacticas(r, nextEuro.scoutKey), nextEuro.scoutKey), rivalNombre: r.nombre };
        }
        if (nextMatch) {
            const r = nextMatch.esLocal ? nextMatch.away : nextMatch.home;
            if (r) {
                const key = `L${career.temporada}-${nextMatch.jornada}-${r.tm_id}`;
                return { pista: scoutingHint(rivalTacticas(r, key), key), rivalNombre: r.nombre };
            }
        }
        return null;
    };

    // Avanza UNA jornada en modo automático (visible, jornada a jornada). Devuelve true si hay que
    // frenar: fin de temporada, oferta de traspaso, eliminatoria del jugador, partido de selección
    // o retiro.
    const runAutoStep = async () => {
        setLoadingAction(true);
        try {
            const data = simulateOneTurnLocal();
            await applyAdvanceResult(data);
            const { career: updatedCareer, resumenTemporada, temporadaFinalizada: finalizada, retirado } = data;
            if (retirado) return true;
            if (resumenTemporada || finalizada) return true;
            if (updatedCareer.ofertas_transferencia?.length > 0) return true;
            if (maybeTriggerEvento(data)) return true; // saltó un evento → frenar el automático
            if (nextTurnIsEuroKnockout(updatedCareer)) return true;
            if (getSeleccionNext(updatedCareer)) return true; // próximo es partido de selección → frenar
            // Mundial del jugador (mitad del año 4): frenamos en la presentación y antes de cada
            // partido para que lo juegues vos (con animación). updatedCareer.seleccion.mundial vivo
            // = todavía hay partidos por jugar.
            if (data.esMundialIntro) return true;
            // Eliminado pero mirando cómo termina: dejamos correr solo (como el espectador), frenamos al final.
            if (data.esMundialEliminadoEspectador) return !!data.mundialEliminadoStep?.fin;
            if (updatedCareer.seleccion?.mundial) return true;
            // Espectador: NO frenamos — dejamos que el Mundial avance solo (paso a paso) con su toast
            // y el panel actualizándose, salvo cuando termina (para que veas el campeón).
            if (data.esEspectadorMundial && data.mundialEspectadorStep?.fin) return true;
            return false;
        } catch (err) {
            toast.error('Error al avanzar la jornada.');
            setLoadingAction(false);
            return true;
        }
    };

    // Modo automático: avanza jornada por jornada (VISIBLE, con su toast) hasta que pasa algo que
    // requiere tu atención o lo detenés. Cada avance es un request liviano.
    useEffect(() => {
        if (!autoMode) return undefined;
        if (career?.ofertas_transferencia?.length > 0) {
            setShowTransferModal(true);
            setAutoMode(false);
            return undefined;
        }
        if (nextTurnIsEuroKnockout(career)) {
            toast.info('⏸ Es un partido de eliminatoria: jugalo vos (Rápido o Lento).');
            setAutoMode(false);
            return undefined;
        }
        if (getSeleccionNext(career)) {
            toast.info('🌍 ¡Te toca con la selección! Jugá el partido vos (Rápido o Lento).');
            setAutoMode(false);
            return undefined;
        }
        if (career?.seleccion?.mundial) {
            toast.info('🌍 Estás en el Mundial. Jugá los partidos vos (Rápido o Lento).');
            setAutoMode(false);
            return undefined;
        }
        let cancelled = false;
        const loop = async () => {
            while (!cancelled) {
                const shouldStop = await runAutoStep();
                if (cancelled) return;
                if (shouldStop) { setAutoMode(false); return; }
                // Delay entre partidos en modo automático: ahora la sim es local e instantánea,
                // así que sin esto pasaría toda la temporada volando. 2s para poder seguirlo.
                await new Promise((resolve) => setTimeout(resolve, 2000));
            }
        };
        loop();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoMode]);

    const decidingRef = useRef(false);
    const handleTransferDecision = async (tm_id) => {
        // Evita doble submit: si ya se está procesando, ignorar (el segundo click llegaba al
        // backend cuando las ofertas ya se habían limpiado → "No tenés ofertas pendientes").
        if (decidingRef.current) return;
        decidingRef.current = true;
        setDecidingTransfer(true);
        try {
            // La sim corre local: el backend procesa el traspaso sobre la carrera GUARDADA, así que
            // persistimos SÍ O SÍ el estado actual (con las ofertas) y esperamos a que confirme. Si
            // el guardado falla, abortamos sin llamar al traspaso (si no, el backend no vería las
            // ofertas y tiraría "No tenés ofertas de traspaso pendientes").
            try {
                await forceSave();
            } catch {
                toast.error('No se pudo guardar tu progreso. Revisá tu conexión y probá de nuevo.');
                return;
            }
            const { career: updatedCareer } = await sendCareerTransferDecision(tm_id);
            careerRef.current = updatedCareer;
            setCareer(updatedCareer);
            setShowTransferModal(false);
            if (tm_id) {
                toast.success(`¡Fichado por ${updatedCareer.club_actual?.nombre}!`);
            }
            await loadDashboardData(updatedCareer);
            checkLogros(updatedCareer, {});
        } catch (err) {
            toast.error('Error al procesar la oferta. Probá de nuevo.');
        } finally {
            decidingRef.current = false;
            setDecidingTransfer(false);
        }
    };

    // Abre el panel de atributos con un borrador (draft) basado en lo que el jugador tiene.
    const handleOpenAtributosModal = () => {
        const base = { ...PM.atributosVacios(), ...(career?.atributos || {}) };
        setAtrDraft({ atributos: { ...base }, puntos: career?.puntos_disponibles || 0, base });
        setShowAtributosModal(true);
    };

    // +1 a un atributo (gasta un punto disponible). -1 solo hasta el valor ya comprometido.
    const ajustarAtributo = (attr, delta) => {
        setAtrDraft((d) => {
            if (!d) return d;
            const cur = d.atributos[attr];
            if (delta > 0 && (d.puntos <= 0 || cur >= 10)) return d;
            if (delta < 0 && cur <= d.base[attr]) return d;
            return { ...d, atributos: { ...d.atributos, [attr]: cur + delta }, puntos: d.puntos - delta };
        });
    };

    // Reset: devuelve todos los puntos asignados para redistribuir, sacrificando 1 punto.
    const resetearAtributos = () => {
        setAtrDraft((d) => {
            if (!d) return d;
            const total = PM.ATRIBUTOS.reduce((s, a) => s + d.atributos[a], 0) + d.puntos;
            const pool = Math.max(0, total - 1);
            return { atributos: PM.atributosVacios(), puntos: pool, base: PM.atributosVacios() };
        });
    };

    // Guarda el borrador en la carrera (local) y persiste en 2º plano. La media NO se recalcula
    // al instante: evoluciona hacia el nuevo potencial al cerrar cada temporada.
    const guardarAtributos = () => {
        if (!atrDraft) return;
        const c = careerRef.current;
        if (c) {
            c.atributos = { ...atrDraft.atributos };
            c.puntos_disponibles = atrDraft.puntos;
            careerRef.current = c;
            setCareer({ ...c });
            scheduleSave();
        }
        setShowAtributosModal(false);
        toast.success('Atributos actualizados.');
    };

    const handleCloseSeasonModal = async () => {
        setShowSeasonModal(false);
        // La temporada se simuló LOCAL: usamos la carrera local más actual (no re-fetchamos del
        // backend, que podría estar desactualizado por el guardado en 2º plano).
        const fresh = careerRef.current;
        if (fresh) {
            setCareer(fresh);
            await loadDashboardData(fresh);
            if (fresh.ofertas_transferencia?.length > 0) {
                setShowTransferModal(true);
            }
        }
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        if (!form.nombre.trim()) {
            toast.error('Ingresá un nombre para tu jugador.');
            return;
        }
        if (!form.nacionalidad) {
            toast.error('Elegí tu nacionalidad.');
            setShowNationalityModal(true);
            return;
        }
        setLoadingAction(true);
        try {
            const { career, clubOptions } = await createCareer(form);
            setCareer(career);
            setClubOptions(clubOptions || []);
            setStep('elegir_club');
        } catch (err) {
            toast.error('Error al crear la partida.');
        } finally {
            setLoadingAction(false);
        }
    };

    const handleChooseClub = async (club) => {
        setLoadingAction(true);
        try {
            const { career } = await chooseCareerClub({
                tm_id: club.tm_id,
                pais: club.pais,
                division: club.division,
            });
            setCareer(career);
            await loadDashboardData(career);
            setStep('dashboard');
        } catch (err) {
            toast.error('Error al elegir el club.');
        } finally {
            setLoadingAction(false);
        }
    };

    // Solo admins: salta directo a cualquier club (testing), tanto al elegir el primer club
    // como ante una oferta de traspaso.
    const handleAdminGoToClub = async (club) => {
        setAdminClubLoading(true);
        try {
            await flushSave();
            const { career: updatedCareer } = await adminGoToClub({
                tm_id: club.tm_id,
                pais: club.pais,
                division: club.division,
            });
            careerRef.current = updatedCareer;
            setCareer(updatedCareer);
            setShowAdminClubPicker(false);
            setShowTransferModal(false);
            setAdminClubSearch('');
            await loadDashboardData(updatedCareer);
            setStep('dashboard');
            toast.success(`(Admin) Ahora jugás en ${updatedCareer.club_actual?.nombre}.`);
        } catch (err) {
            toast.error('Error al cambiar de club (admin).');
        } finally {
            setAdminClubLoading(false);
        }
    };

    // Agrega goles/asistencias/partidos por club a lo largo de toda la carrera (temporadas
    // terminadas + la temporada en curso) para mostrar la trayectoria al retirarse.
    // La edad arranca en 18 en la temporada 1, así que durante la temporada T tenés 17 + T años.
    const edadEnTemporada = (temp) => 17 + temp;

    // Resumen de selección nacional para la imagen + modal de retiro. Devuelve null si el
    // jugador nunca jugó con su selección (nacionalidad sin selección, o nunca lo convocaron).
    const LLEGO_RANK = { campeon: 7, final: 6, semis: 5, cuartos: 4, octavos: 3, '16avos': 2, grupos: 1, no_clasif: 0 };
    const LLEGO_LABEL = { campeon: '🏆 Campeón', final: '🥈 Final', semis: 'Semifinal', cuartos: 'Cuartos', octavos: 'Octavos', '16avos': '16avos', grupos: 'Fase de grupos', no_clasif: 'No clasificó' };
    const buildSeleccionResumen = () => {
        if (!career) return null;
        const sel = seleccionDelJugador(career);
        if (!sel) return null;
        const mundiales = career.mundiales_historicos || [];
        const carrera = career.seleccion_carrera || { partidos: 0, goles: 0, asistencias: 0 };
        if (mundiales.length === 0 && carrera.partidos === 0) return null;
        const mundialesOrdenados = [...mundiales].sort((a, b) => (LLEGO_RANK[b.llego_a] || 0) - (LLEGO_RANK[a.llego_a] || 0));
        const mejor = mundialesOrdenados[0] || null;
        return {
            pais: sel.pais,
            nombre: sel.nombre,
            estrellas: sel.estrellas,
            partidos: carrera.partidos || 0,
            goles: carrera.goles || 0,
            asistencias: carrera.asistencias || 0,
            mundiales_disputados: mundiales.filter(m => m.jugador_jugo).length,
            mejor,
            mundiales: [...mundiales].sort((a, b) => a.edad_jugador - b.edad_jugador),
        };
    };

    const buildTrayectoria = () => {
        // Reunimos cada temporada (historial + la actual) como un registro suelto y las ordenamos
        // cronológicamente. Después agrupamos en "etapas" (stints): temporadas CONSECUTIVAS en el
        // mismo club se fusionan, pero si te fuiste y volviste, aparecen como dos etapas separadas
        // en orden cronológico (ej.: Club 29–30 y más abajo Club 34–38).
        const seasons = [];
        let ligas = 0, champions = 0, europa = 0, libertadores = 0, sudamericana = 0;
        let mejorRating = career?.rating || 0;
        for (const s of career?.historial_stats || []) {
            seasons.push({
                temporada: s.temporada,
                nombre: s.club_nombre,
                logo: s.club_logo,
                partidos: s.partidos || 0,
                goles: s.goles || 0,
                asistencias: s.asistencias || 0,
            });
            for (const t of s.titulos || []) {
                if (/Champions League/i.test(t)) champions += 1;
                else if (/Europa League/i.test(t)) europa += 1;
                else if (/Libertadores/i.test(t)) libertadores += 1;
                else if (/Sudamericana/i.test(t)) sudamericana += 1;
                else ligas += 1;
            }
            if (s.rating_final > mejorRating) mejorRating = s.rating_final;
        }
        if (career?.club_actual && career?.stats_temporada) {
            seasons.push({
                temporada: career.temporada,
                nombre: career.club_actual.nombre,
                logo: career.club_actual.logo,
                partidos: career.stats_temporada.partidos || 0,
                goles: career.stats_temporada.goles || 0,
                asistencias: career.stats_temporada.asistencias || 0,
            });
        }
        seasons.sort((a, b) => (a.temporada ?? 0) - (b.temporada ?? 0));

        const stints = [];
        for (const s of seasons) {
            const last = stints[stints.length - 1];
            if (last && last.nombre === s.nombre) {
                last.partidos += s.partidos; last.goles += s.goles; last.asistencias += s.asistencias;
                last.tempMax = s.temporada;
                if (s.logo && !last.logo) last.logo = s.logo;
            } else {
                stints.push({
                    nombre: s.nombre, logo: s.logo,
                    partidos: s.partidos, goles: s.goles, asistencias: s.asistencias,
                    tempMin: s.temporada, tempMax: s.temporada,
                });
            }
        }
        const clubs = stints
            .filter((c) => c.partidos > 0 || c.goles > 0 || c.asistencias > 0)
            .map((c) => ({
                ...c,
                edadDesde: c.tempMin != null ? edadEnTemporada(c.tempMin) : null,
                edadHasta: c.tempMax != null ? edadEnTemporada(c.tempMax) : null,
            }));
        const totales = {
            partidos: clubs.reduce((s, c) => s + c.partidos, 0),
            goles: clubs.reduce((s, c) => s + c.goles, 0),
            asistencias: clubs.reduce((s, c) => s + c.asistencias, 0),
            titulos: ligas + champions + europa + libertadores + sudamericana,
            ligas, champions, europa, libertadores, sudamericana,
            temporadas: (career?.historial_stats?.length || 0) + 1,
            mejorRating,
        };
        return { clubs, totales };
    };

    const shareText = (totales) => {
        const partes = [`🏆 ${totales.ligas} liga${totales.ligas !== 1 ? 's' : ''}`];
        if (totales.champions) partes.push(`🏆 ${totales.champions} Champions`);
        if (totales.europa) partes.push(`🌍 ${totales.europa} Europa`);
        if (totales.libertadores) partes.push(`🏆 ${totales.libertadores} Libertadores`);
        if (totales.sudamericana) partes.push(`🥈 ${totales.sudamericana} Sudamericana`);
        const palmares = partes.join(' · ');
        return `Colgué los botines 🎙️\n\nMi carrera como ${career.nombre} (${career.posicion}):\n⚽ ${totales.goles} goles · 🅰️ ${totales.asistencias} asistencias en ${totales.partidos} partidos\n${palmares}\n📈 Mejor media ${totales.mejorRating}\n\n¡Jugá tu carrera en www.footy-games.com.ar!`;
    };

    // Carga una imagen remota para dibujarla en canvas. Usa crossOrigin anónimo: si el
    // servidor no manda CORS la carga falla y devolvemos null (así el canvas nunca se
    // "ensucia" y la exportación a PNG sigue funcionando).
    const loadImageForCanvas = (src) => new Promise((resolve) => {
        if (!src) return resolve(null);
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = () => resolve(null);
        img.src = src;
    });

    const roundRect = (ctx, x, y, w, h, r) => {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + w, y, x + w, y + h, r);
        ctx.arcTo(x + w, y + h, x, y + h, r);
        ctx.arcTo(x, y + h, x, y, r);
        ctx.arcTo(x, y, x + w, y, r);
        ctx.closePath();
    };

    // Dibuja una tarjeta profesional y simétrica con toda la carrera y la devuelve como canvas
    // listo para exportar a PNG. Estructura:
    //   [ Foto | Nombre + bio | Mejor media ]
    //              Estadísticas
    //               Palmarés
    //   Todos los clubs con sus stats (en orden cronológico; la imagen crece a lo largo).
    //              Jugá tu carrera en www.footy-games.com.ar
    const buildCareerCanvas = async ({ clubs, totales, seleccion }) => {
        const W = 1080, M = 64;
        const innerW = W - 2 * M;
        const rowH = 64, rowGap = 10;

        // Paleta y helpers de fuente.
        const GOLD = '#facc15', GOLD_SOFT = 'rgba(250,204,21,0.16)';
        const LIGHT = '#f8fafc', MUTED = '#9fd3b4', DARK = '#04140c';
        const center = W / 2;
        const F = (w, s) => `${w} ${s}px Arial, "Helvetica Neue", sans-serif`;

        // --- Cálculo de alturas de cada bloque para centrar todo verticalmente ---
        const titleH = 96;
        const headerH = 312;          // bloque Foto | Bio | Media
        const statsH = 168;           // panel de estadísticas
        const palmaresLabelH = 86;    // título "Palmarés"
        const palmRowH = 64;          // alto de cada fila de chips de palmarés
        const trajLabelH = 78;        // título "Trayectoria"
        const footerH = 92;
        const BLOCK_GAP = 30;

        // Chips de palmarés: arman filas centradas; calculamos cuántas filas ocupan.
        const palmParts = [{ ic: '🏆', n: totales.ligas, l: totales.ligas === 1 ? 'Liga' : 'Ligas' }];
        if (totales.champions) palmParts.push({ ic: '🏆', n: totales.champions, l: 'Champions' });
        if (totales.europa) palmParts.push({ ic: '🌍', n: totales.europa, l: 'Europa L.' });
        if (totales.libertadores) palmParts.push({ ic: '🏆', n: totales.libertadores, l: 'Libertadores' });
        if (totales.sudamericana) palmParts.push({ ic: '🥈', n: totales.sudamericana, l: 'Sudamericana' });
        const palmRows = Math.ceil(palmParts.length / 3);
        const palmaresH = palmaresLabelH + palmRows * palmRowH;

        const trajRowsH = clubs.length * rowH + Math.max(0, clubs.length - 1) * rowGap;
        const trajH = trajLabelH + trajRowsH;

        // ===== Selección Nacional (opcional) =====
        // Si el jugador tiene selección y al menos jugó algo, sumamos un bloque entre Palmarés y
        // Trayectoria. Estructura: título + chips (mundiales/goles/asist/partidos) + lista compacta
        // de mundiales (uno por fila).
        const selLabelH = 76;
        const selChipsH = 64;
        const selRowH = 36;
        const selH = seleccion ? (selLabelH + selChipsH + 16 + seleccion.mundiales.length * selRowH + 14) : 0;

        const H = titleH + headerH + statsH + palmaresH + selH + trajH + footerH + BLOCK_GAP * (seleccion ? 5 : 4) + 48;

        const dpr = 2;
        const canvas = document.createElement('canvas');
        canvas.width = W * dpr;
        canvas.height = H * dpr;
        const ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);
        ctx.textBaseline = 'alphabetic';

        // Fondo: degradé verde oscuro + marco dorado.
        const grad = ctx.createLinearGradient(0, 0, 0, H);
        grad.addColorStop(0, '#04160d');
        grad.addColorStop(0.55, '#062013');
        grad.addColorStop(1, '#031a0f');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, W, H);
        ctx.strokeStyle = 'rgba(250,204,21,0.35)';
        ctx.lineWidth = 3;
        roundRect(ctx, 14, 14, W - 28, H - 28, 30);
        ctx.stroke();

        // Helpers de texto.
        const drawCenter = (text, y, font, color, spacing = 0) => {
            ctx.font = font; ctx.fillStyle = color;
            if (spacing) {
                const chars = [...text];
                const total = chars.reduce((s, c) => s + ctx.measureText(c).width + spacing, 0) - spacing;
                let x = center - total / 2;
                for (const c of chars) { ctx.fillText(c, x, y); x += ctx.measureText(c).width + spacing; }
            } else {
                ctx.textAlign = 'center'; ctx.fillText(text, center, y); ctx.textAlign = 'left';
            }
        };
        // Título de sección centrado, con una línea dorada a cada lado (simétrico).
        const sectionTitle = (text, y) => {
            ctx.font = F(700, 24);
            const tw = ctx.measureText(text).width + 24 * 2;
            drawCenter(text.toUpperCase(), y, F(700, 24), GOLD, 4);
            const lineW = 90;
            const gap = (tw + 24);
            ctx.strokeStyle = 'rgba(250,204,21,0.4)';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(center - gap / 2 - lineW, y - 8); ctx.lineTo(center - gap / 2, y - 8);
            ctx.moveTo(center + gap / 2, y - 8); ctx.lineTo(center + gap / 2 + lineW, y - 8);
            ctx.stroke();
        };

        let y = 0;

        // ===== Título =====
        drawCenter('⚽  FOOTY · MODO CARRERA', 70, F(800, 27), GOLD, 4);
        y = titleH;

        // ===== Header: Foto | Nombre+bio | Mejor media =====
        const headerY = y;
        // Panel de fondo del header.
        ctx.fillStyle = 'rgba(255,255,255,0.035)';
        roundRect(ctx, M, headerY, innerW, headerH - BLOCK_GAP, 22); ctx.fill();
        ctx.strokeStyle = 'rgba(250,204,21,0.14)'; ctx.lineWidth = 1.5;
        roundRect(ctx, M, headerY, innerW, headerH - BLOCK_GAP, 22); ctx.stroke();

        const hPanelH = headerH - BLOCK_GAP;
        const colW = innerW / 3;
        const col1Cx = M + colW * 0.5;
        const col2Cx = M + colW * 1.5;
        const col3Cx = M + colW * 2.5;
        // Divisores verticales entre columnas (simetría).
        ctx.strokeStyle = 'rgba(255,255,255,0.08)'; ctx.lineWidth = 1;
        [M + colW, M + colW * 2].forEach((dx) => {
            ctx.beginPath(); ctx.moveTo(dx, headerY + 28); ctx.lineTo(dx, headerY + hPanelH - 28); ctx.stroke();
        });

        // Col 1: avatar centrado.
        const avatarH = hPanelH - 56, avatarW = avatarH * (300 / 480);
        const avatarX = col1Cx - avatarW / 2, avatarY = headerY + 28;
        const avatarImg = await loadImageForCanvas(avatarToDataUri(career.avatar, Math.round(avatarW * 2), career.altura, career.peso));
        if (avatarImg) ctx.drawImage(avatarImg, avatarX, avatarY, avatarW, avatarH);

        // Col 2: nombre + bio, centrados vertical y horizontalmente.
        const midY = headerY + hPanelH / 2;
        ctx.textAlign = 'center';
        // Nombre (achica fuente si no entra).
        let nameFont = 44;
        const nombreUp = (career.nombre || '').toUpperCase();
        ctx.font = F(800, nameFont);
        while (ctx.measureText(nombreUp).width > colW - 30 && nameFont > 26) { nameFont -= 2; ctx.font = F(800, nameFont); }
        ctx.fillStyle = LIGHT;
        ctx.fillText(nombreUp, col2Cx, midY - 28);
        ctx.fillStyle = GOLD;
        ctx.font = F(600, 21);
        ctx.fillText(career.posicion || '', col2Cx, midY + 12);
        ctx.fillStyle = MUTED;
        ctx.font = F(500, 20);
        ctx.fillText(`${career.nacionalidad || ''}`, col2Cx, midY + 44);
        ctx.fillText(`${totales.temporadas} temporada${totales.temporadas !== 1 ? 's' : ''} · ${career.edad} años`, col2Cx, midY + 74);
        ctx.textAlign = 'left';

        // Col 3: disco de mejor media, centrado.
        const discR = 70, discCx = col3Cx, discCy = midY - 14;
        ctx.beginPath(); ctx.arc(discCx, discCy, discR + 6, 0, Math.PI * 2);
        ctx.fillStyle = GOLD_SOFT; ctx.fill();
        ctx.beginPath(); ctx.arc(discCx, discCy, discR, 0, Math.PI * 2);
        ctx.fillStyle = GOLD; ctx.fill();
        ctx.fillStyle = DARK; ctx.textAlign = 'center';
        ctx.font = F(800, 60); ctx.fillText(String(totales.mejorRating), discCx, discCy + 20);
        // Etiqueta "MEJOR MEDIA" centrada DEBAJO del disco (en la 3ª columna), con tracking.
        ctx.font = F(700, 20); ctx.fillStyle = MUTED;
        const lbl = 'MEJOR MEDIA', lblSp = 3;
        const lblW = [...lbl].reduce((s, ch) => s + ctx.measureText(ch).width + lblSp, 0) - lblSp;
        let lx = discCx - lblW / 2; const ly = discCy + discR + 44;
        ctx.textAlign = 'left';
        for (const ch of lbl) { ctx.fillText(ch, lx, ly); lx += ctx.measureText(ch).width + lblSp; }

        y = headerY + headerH;

        // ===== Estadísticas =====
        sectionTitle('Estadísticas', y + 14);
        const statsPanelY = y + 38, statsPanelH = statsH - 56;
        ctx.fillStyle = 'rgba(255,255,255,0.04)';
        roundRect(ctx, M, statsPanelY, innerW, statsPanelH, 18); ctx.fill();
        ctx.strokeStyle = 'rgba(250,204,21,0.18)'; ctx.lineWidth = 1.5;
        roundRect(ctx, M, statsPanelY, innerW, statsPanelH, 18); ctx.stroke();
        const statCols = [
            { v: totales.partidos, l: 'PARTIDOS' },
            { v: totales.goles, l: 'GOLES' },
            { v: totales.asistencias, l: 'ASISTENCIAS' },
            { v: totales.titulos, l: 'TÍTULOS' },
        ];
        const sColW = innerW / statCols.length;
        statCols.forEach((c, i) => {
            const cx = M + sColW * i + sColW / 2;
            if (i > 0) {
                ctx.strokeStyle = 'rgba(255,255,255,0.08)'; ctx.lineWidth = 1;
                ctx.beginPath(); ctx.moveTo(M + sColW * i, statsPanelY + 24); ctx.lineTo(M + sColW * i, statsPanelY + statsPanelH - 24); ctx.stroke();
            }
            ctx.textAlign = 'center';
            ctx.fillStyle = GOLD; ctx.font = F(800, 46);
            ctx.fillText(String(c.v), cx, statsPanelY + 64);
            ctx.fillStyle = MUTED; ctx.font = F(600, 19);
            ctx.fillText(c.l, cx, statsPanelY + 98);
            ctx.textAlign = 'left';
        });
        y += statsH;

        // ===== Palmarés =====
        sectionTitle('Palmarés', y + 14);
        let py = y + palmaresLabelH - 8;
        ctx.font = F(700, 22);
        const chipPad = 22, chipH = 50, chipGap = 16;
        // Medimos cada chip y los repartimos en filas de a 3, centradas.
        const chips = palmParts.map((p) => {
            const txt = `${p.ic} ${p.n} ${p.l}`;
            const w = ctx.measureText(txt).width + chipPad * 2;
            return { txt, w };
        });
        for (let r = 0; r < palmRows; r++) {
            const rowChips = chips.slice(r * 3, r * 3 + 3);
            const totalW = rowChips.reduce((s, c) => s + c.w, 0) + (rowChips.length - 1) * chipGap;
            let cx = center - totalW / 2;
            const cy = py + r * palmRowH;
            rowChips.forEach((c) => {
                ctx.fillStyle = GOLD_SOFT;
                roundRect(ctx, cx, cy, c.w, chipH, chipH / 2); ctx.fill();
                ctx.strokeStyle = 'rgba(250,204,21,0.35)'; ctx.lineWidth = 1.5;
                roundRect(ctx, cx, cy, c.w, chipH, chipH / 2); ctx.stroke();
                ctx.fillStyle = LIGHT; ctx.font = F(700, 22); ctx.textAlign = 'center';
                ctx.fillText(c.txt, cx + c.w / 2, cy + chipH / 2 + 8);
                ctx.textAlign = 'left';
                cx += c.w + chipGap;
            });
        }
        y += palmaresH;

        // ===== Selección Nacional (opcional) =====
        if (seleccion) {
            y += BLOCK_GAP;
            sectionTitle('Selección Nacional', y + 14);
            // Subtítulo: bandera (omitida en canvas por simplicidad) + nombre + estrellas
            ctx.fillStyle = LIGHT; ctx.font = F(700, 22); ctx.textAlign = 'center';
            const sub = `${seleccion.nombre} · ${'★'.repeat(Math.floor(seleccion.estrellas))}${seleccion.estrellas % 1 ? '½' : ''}`;
            ctx.fillText(sub, center, y + 56);
            ctx.textAlign = 'left';

            // Chips de stats (mundiales/goles/asistencias/partidos), 4 chips en una fila centrada
            const selChips = [
                `🌍 ${seleccion.mundiales_disputados} ${seleccion.mundiales_disputados === 1 ? 'Mundial' : 'Mundiales'}`,
                `⚽ ${seleccion.goles} Goles`,
                `🅰️ ${seleccion.asistencias} Asist.`,
                `📋 ${seleccion.partidos} PJ`,
            ];
            ctx.font = F(700, 20);
            const sChipPad = 18, sChipH = 44, sChipGap = 12;
            const sChipMeas = selChips.map(t => ({ t, w: ctx.measureText(t).width + sChipPad * 2 }));
            const sChipsTotalW = sChipMeas.reduce((s, c) => s + c.w, 0) + (sChipMeas.length - 1) * sChipGap;
            let scx = center - sChipsTotalW / 2;
            const scy = y + selLabelH + 8;
            sChipMeas.forEach(c => {
                ctx.fillStyle = GOLD_SOFT;
                roundRect(ctx, scx, scy, c.w, sChipH, sChipH / 2); ctx.fill();
                ctx.strokeStyle = 'rgba(250,204,21,0.35)'; ctx.lineWidth = 1.5;
                roundRect(ctx, scx, scy, c.w, sChipH, sChipH / 2); ctx.stroke();
                ctx.fillStyle = LIGHT; ctx.font = F(700, 20); ctx.textAlign = 'center';
                ctx.fillText(c.t, scx + c.w / 2, scy + sChipH / 2 + 7);
                ctx.textAlign = 'left';
                scx += c.w + sChipGap;
            });

            // Lista compacta de mundiales (uno por fila)
            let my = scy + selChipsH + 12;
            ctx.font = F(700, 18);
            for (const m of seleccion.mundiales) {
                const lbl = LLEGO_LABEL[m.llego_a] || m.llego_a;
                const left = `Mundial #${m.ciclo} · edad ${m.edad_jugador}`;
                const right = `${lbl}${m.llego_a === 'campeon' ? '' : (m.partidos ? `  ·  ${m.partidos} PJ  ·  ${m.goles}G` : '')}`;
                ctx.fillStyle = MUTED; ctx.fillText(left, M + 22, my + 22);
                ctx.fillStyle = m.llego_a === 'campeon' ? GOLD : LIGHT;
                const rw = ctx.measureText(right).width;
                ctx.fillText(right, W - M - 22 - rw, my + 22);
                my += selRowH;
            }
            y += selH;
        }

        // ===== Trayectoria =====
        sectionTitle('Trayectoria', y + 14);
        let ty = y + trajLabelH - 8;
        const logos = await Promise.all(clubs.map((c) => loadImageForCanvas(c.logo)));
        clubs.forEach((c, i) => {
            const ry = ty + i * (rowH + rowGap);
            ctx.fillStyle = i % 2 === 0 ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.025)';
            roundRect(ctx, M, ry, innerW, rowH, 14); ctx.fill();
            ctx.strokeStyle = 'rgba(255,255,255,0.06)'; ctx.lineWidth = 1;
            roundRect(ctx, M, ry, innerW, rowH, 14); ctx.stroke();

            const logoCx = M + 38, logoCy = ry + rowH / 2, logoR = 24;
            const img = logos[i];
            if (img) {
                ctx.save();
                ctx.beginPath(); ctx.arc(logoCx, logoCy, logoR, 0, Math.PI * 2); ctx.closePath(); ctx.clip();
                ctx.drawImage(img, logoCx - logoR, logoCy - logoR, logoR * 2, logoR * 2);
                ctx.restore();
            } else {
                ctx.beginPath(); ctx.arc(logoCx, logoCy, logoR, 0, Math.PI * 2);
                ctx.fillStyle = GOLD_SOFT; ctx.fill();
                ctx.fillStyle = GOLD; ctx.font = F(700, 22); ctx.textAlign = 'center';
                ctx.fillText((c.nombre || '?').charAt(0).toUpperCase(), logoCx, logoCy + 8);
                ctx.textAlign = 'left';
            }

            const textX = logoCx + logoR + 20;
            ctx.fillStyle = LIGHT; ctx.font = F(700, 25);
            let nombre = c.nombre || '';
            while (ctx.measureText(nombre).width > 440 && nombre.length > 3) nombre = nombre.slice(0, -1);
            if (nombre !== (c.nombre || '')) nombre += '…';
            const hasAge = c.edadDesde != null;
            ctx.fillText(nombre, textX, hasAge ? logoCy - 3 : logoCy + 9);
            if (hasAge) {
                ctx.fillStyle = MUTED; ctx.font = F(500, 18);
                const rango = c.edadDesde === c.edadHasta ? `${c.edadDesde} años` : `${c.edadDesde}–${c.edadHasta} años`;
                ctx.fillText(rango, textX, logoCy + 22);
            }
            // Stats alineadas a la derecha SIN textAlign='right' ni emojis: Safari de iOS calcula
            // mal el ancho con emojis y el texto se desborda fuera de la imagen. Posicionamos
            // manualmente con measureText (texto plano = ancho consistente en todas las plataformas).
            ctx.fillStyle = GOLD; ctx.font = F(700, 22); ctx.textAlign = 'left';
            const statsTxt = `${c.partidos} PJ · ${c.goles} G · ${c.asistencias} A`;
            const statsW = ctx.measureText(statsTxt).width;
            ctx.fillText(statsTxt, W - M - 22 - statsW, logoCy + 8);
        });
        y += trajH;

        // ===== Footer =====
        ctx.strokeStyle = 'rgba(250,204,21,0.25)'; ctx.lineWidth = 1.5;
        ctx.beginPath(); ctx.moveTo(M, y + 20); ctx.lineTo(W - M, y + 20); ctx.stroke();
        drawCenter('Jugá tu carrera en www.footy-games.com.ar', y + 60, F(700, 24), GOLD);

        return canvas;
    };

    // Genera la imagen de la carrera y la comparte. En mobile (y navegadores que soporten
    // compartir archivos) abre el menú nativo, que adjunta la imagen directo a la app elegida
    // (X, WhatsApp, etc). Si no está disponible, copia el texto al portapapeles y descarga la
    // imagen para que el usuario la adjunte manualmente.
    const shareCareerImage = async () => {
        if (sharing) return;
        setSharing(true);
        try {
            const { clubs, totales } = buildTrayectoria();
            const canvas = await buildCareerCanvas({ clubs, totales, seleccion: buildSeleccionResumen() });
            const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
            if (!blob) { toast.error('No se pudo generar la imagen.'); return; }
            const file = new File([blob], 'mi-carrera-footy.png', { type: 'image/png' });
            const text = shareText(totales);

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({ files: [file], text, title: 'Mi carrera en Footy' });
                    return;
                } catch (e) {
                    if (e?.name === 'AbortError') return; // el usuario canceló
                    // si falla, seguimos con el fallback de descarga
                }
            }

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'mi-carrera-footy.png';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);

            try {
                await navigator.clipboard.writeText(text);
                toast.success('Imagen descargada y texto copiado. Pegalo en tu posteo 📸');
            } catch {
                toast.success('Imagen de tu carrera descargada 📸');
            }
        } catch (err) {
            toast.error('No se pudo generar la imagen.');
        } finally {
            setSharing(false);
        }
    };

    // Descarga directa de la imagen de la carrera como PNG (sin abrir el menú de compartir).
    const downloadCareerImage = async () => {
        if (sharing) return;
        setSharing(true);
        try {
            const { clubs, totales } = buildTrayectoria();
            const canvas = await buildCareerCanvas({ clubs, totales, seleccion: buildSeleccionResumen() });
            const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
            if (!blob) { toast.error('No se pudo generar la imagen.'); return; }
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `carrera-${(career.nombre || 'footy').toLowerCase().replace(/\s+/g, '-')}.png`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
            toast.success('Imagen de tu carrera descargada 📥');
        } catch (err) {
            toast.error('No se pudo generar la imagen.');
        } finally {
            setSharing(false);
        }
    };

    const confirmRetire = async () => {
        setLoadingAction(true);
        try {
            // Retiro VOLUNTARIO (no por edad): cuenta para logros de retiro que valen con cualquier
            // retiro (p. ej. "Bandera del club"), pero NO para el imposible que exige retiro por edad.
            // Se evalúa ANTES de borrar la carrera. (El retiro forzado por edad ya se evaluó al avanzar.)
            if (!forcedRetire && careerRef.current) {
                await checkLogros(careerRef.current, { retired: true, retiredByAge: false });
            }
            await deleteCareer();
            setShowRetireModal(false);
            setForcedRetire(false);
            setCareer(null);
            setClubOptions([]);
            setStandings(null);
            setNextMatch(null);
            setNextEuro(null);
            setTemporadaFinalizada(false);
            setForm({ nombre: '', nacionalidad: '', posicion: POSITIONS[0], altura: FISICO_DEFAULT.altura, peso: FISICO_DEFAULT.peso, atributos: PM.atributosVacios(), avatar: { ...AVATAR_DEFAULT } });
            setStep('crear_personaje');
        } catch (err) {
            toast.error('Error al retirarse.');
        } finally {
            setLoadingAction(false);
        }
    };

    // En mantenimiento y no sos admin: cartel (overlay). El juego se cargó igual por detrás pero
    // no se muestra.
    if (maintenance && !isAdmin) {
        return (
            <div className="cs-page">
                <Navbar />
                <div className="cs-container">
                    <div className="cs-card cs-narrow" style={{ textAlign: 'center', padding: '48px 24px', marginTop: 40 }}>
                        <div style={{ fontSize: 56, marginBottom: 12 }}>🔧⚽</div>
                        <h1 className="cs-title" style={{ fontSize: 24 }}>MODO CARRERA EN MANTENIMIENTO</h1>
                        <p className="cs-subtitle" style={{ fontSize: 15, marginTop: 12 }}>
                            Estamos mejorando el juego con un montón de novedades.
                        </p>
                        <p className="cs-subtitle" style={{ fontSize: 15 }}>
                            ¡Pronto van a poder volver a jugar! 🙌
                        </p>
                        <p className="cs-hint" style={{ marginTop: 20 }}>
                            Gracias por la paciencia 💛
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="cs-page">
            <Navbar />

            {maintenance && isAdmin && (
                <div className="cs-admin-maint-banner">
                    🔧 Modo carrera EN MANTENIMIENTO — solo los admins pueden jugar. (Cambialo desde el panel de admin.)
                </div>
            )}

            <div className="cs-container">
            {step === 'no_auth' && (
                <div className="cs-card cs-creator cs-noauth">
                    <h1 className="cs-title">⚽ MODO CARRERA</h1>
                    <p className="cs-noauth-text">
                        Necesitás iniciar sesión para jugar al Modo Carrera. Así guardamos tu progreso y tus logros.
                    </p>
                    <a className="cs-btn cs-btn-primary cs-noauth-btn" href="/login">Iniciar sesión</a>
                    <a className="cs-noauth-link" href="/">Volver al inicio</a>
                </div>
            )}

            {step === 'loading' && (
                <div className="cs-loading">
                    <div className="cs-loading-spinner" />
                    <span>Cargando modo carrera...</span>
                </div>
            )}

            {step === 'crear_personaje' && (
                <div className="cs-card cs-creator">
                    <h1 className="cs-title">⚽ MODO CARRERA</h1>
                    <p className="cs-subtitle">Creá tu jugador y empezá tu historia desde cero.</p>
                    <form className="cs-creator-grid" onSubmit={handleCreate}>
                        <div className="cs-creator-preview">
                            <div className="cs-avatar-stage">
                                <PlayerAvatar avatar={form.avatar} size={150} altura={form.altura} peso={form.peso} />
                            </div>
                            <div className="cs-avatar-name">
                                {getFlagUrl(form.nacionalidad) && (
                                    <img className="cs-flag cs-flag-inline" src={getFlagUrl(form.nacionalidad)} alt={form.nacionalidad} />
                                )}
                                {form.nombre || 'Tu jugador'}
                            </div>
                            <div className="cs-avatar-pos">{form.posicion}</div>
                        </div>

                        <div className="cs-creator-fields">
                            <div className="cs-creator-tabs">
                                {[['datos', '📋 Datos'], ['cabeza', '🧑 Cabeza'], ['cuerpo', '👕 Cuerpo']].map(([k, lbl]) => (
                                    <button
                                        key={k}
                                        type="button"
                                        className={`cs-creator-tab${creatorSection === k ? ' active' : ''}`}
                                        onClick={() => setCreatorSection(k)}
                                    >
                                        {lbl}
                                    </button>
                                ))}
                            </div>

                            {creatorSection === 'datos' && (<>
                            <label className="cs-label">
                                Nombre
                                <input
                                    className="cs-input"
                                    type="text"
                                    value={form.nombre}
                                    maxLength={30}
                                    onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                                    placeholder="Tu nombre de jugador"
                                />
                            </label>

                            <label className="cs-label">
                                Nacionalidad
                                <button
                                    type="button"
                                    className="cs-input cs-input--with-flag cs-nationality-btn"
                                    onClick={() => setShowNationalityModal(true)}
                                >
                                    {getFlagUrl(form.nacionalidad) && (
                                        <img className="cs-flag" src={getFlagUrl(form.nacionalidad)} alt={form.nacionalidad} />
                                    )}
                                    <span className={form.nacionalidad ? '' : 'cs-nationality-placeholder'}>{form.nacionalidad || 'Elegí tu nacionalidad'}</span>
                                    <span className="cs-nationality-btn-arrow">▾</span>
                                </button>
                            </label>

                            <div className="cs-label">
                                Posición
                                <div className="cs-pos-options">
                                    {POSITIONS.map((p) => (
                                        <button
                                            key={p}
                                            type="button"
                                            className={`cs-pos-btn${form.posicion === p ? ' active' : ''}`}
                                            onClick={() => setForm({ ...form, posicion: p })}
                                        >
                                            <span className="cs-pos-btn-abbr">{POSITION_ABBR[p]}</span>
                                            <span className="cs-pos-btn-name">{p}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>

            {/* Físico: altura y peso. El peso se limita a (altura−100) ± 25, dentro de los
                límites globales (p. ej. a 1.80m → 55-105 kg). Al cambiar la altura, se reencuadra. */}
                            {(() => {
                                const pesoMin = Math.max(PM.PESO_MIN, (form.altura - 100) - 25);
                                const pesoMax = Math.min(PM.PESO_MAX, (form.altura - 100) + 25);
                                const setAltura = (alturaN) => {
                                    const pMin = Math.max(PM.PESO_MIN, (alturaN - 100) - 25);
                                    const pMax = Math.min(PM.PESO_MAX, (alturaN - 100) + 25);
                                    const peso = Math.max(pMin, Math.min(pMax, form.peso));
                                    setForm({ ...form, altura: alturaN, peso });
                                };
                                return (
                                    <div className="cs-label">
                                        Físico
                                        <span className="cs-slider-label">Altura: {(form.altura / 100).toFixed(2)} m</span>
                                        <input className="cs-slider" type="range" min={PM.ALTURA_MIN} max={PM.ALTURA_MAX} value={form.altura}
                                            onChange={(e) => setAltura(Number(e.target.value))} />
                                        <span className="cs-slider-label">Peso: {form.peso} kg ({pesoMin}-{pesoMax})</span>
                                        <input className="cs-slider" type="range" min={pesoMin} max={pesoMax} value={form.peso}
                                            onChange={(e) => setForm({ ...form, peso: Number(e.target.value) })} />
                                    </div>
                                );
                            })()}

                            {/* Atributos: 3 puntos para repartir (orden neutro, sin sugerir dónde). */}
                            {(() => {
                                const usados = PM.ATRIBUTOS.reduce((s, a) => s + (form.atributos[a] || 0), 0);
                                const disp = 3 - usados;
                                const ajustar = (attr, delta) => {
                                    const cur = form.atributos[attr] || 0;
                                    if (delta > 0 && (disp <= 0 || cur >= 10)) return;
                                    if (delta < 0 && cur <= 0) return;
                                    setForm({ ...form, atributos: { ...form.atributos, [attr]: cur + delta } });
                                };
                                return (
                                    <div className="cs-label">
                                        Atributos · puntos a repartir: <b>{disp}</b>
                                        <div className="cs-attr-list">
                                            {PM.ATRIBUTOS.map((attr) => {
                                                const val = form.atributos[attr] || 0;
                                                return (
                                                    <div className="cs-attr-row" key={attr}>
                                                        <span className="cs-attr-name">{PM.ATRIBUTO_LABEL[attr]}</span>
                                                        <div className="cs-attr-bar"><div className="cs-attr-bar-fill" style={{ width: `${val * 10}%` }} /></div>
                                                        <button type="button" className="cs-attr-btn" onClick={() => ajustar(attr, -1)} disabled={val <= 0}>−</button>
                                                        <span className="cs-attr-val">{val}</span>
                                                        <button type="button" className="cs-attr-btn" onClick={() => ajustar(attr, 1)} disabled={disp <= 0 || val >= 10}>+</button>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })()}
                            </>)}

                            {creatorSection === 'cabeza' && (<>
                            <div className="cs-label">
                                Piel
                                <ColorRow value={form.avatar.piel} quick={QUICK_PIEL} onChange={(c) => setAvatar({ piel: c })} label="Piel" />
                            </div>

                            <div className="cs-label">
                                Peinado
                                <div className="cs-chip-options">
                                    {PEINADOS.map((p) => (
                                        <button
                                            key={p.value}
                                            type="button"
                                            className={`cs-chip-btn${form.avatar.peinado === p.value ? ' active' : ''}`}
                                            onClick={() => setAvatar({ peinado: p.value })}
                                        >
                                            {p.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {form.avatar.peinado !== 'pelado' && (
                                <div className="cs-label">
                                    Color de pelo
                                    <ColorRow value={form.avatar.pelo_color} quick={QUICK_PELO} onChange={(c) => setAvatar({ pelo_color: c })} label="Pelo" />
                                </div>
                            )}

                            <div className="cs-label">
                                Barba
                                <div className="cs-chip-options">
                                    {BARBAS.map((b) => (
                                        <button
                                            key={b.value}
                                            type="button"
                                            className={`cs-chip-btn${form.avatar.barba === b.value ? ' active' : ''}`}
                                            onClick={() => setAvatar({ barba: b.value })}
                                        >
                                            {b.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="cs-label">
                                Lentes
                                <div className="cs-chip-options">
                                    {LENTES.map((l) => (
                                        <button
                                            key={l.value}
                                            type="button"
                                            className={`cs-chip-btn${form.avatar.lentes === l.value ? ' active' : ''}`}
                                            onClick={() => setAvatar({ lentes: l.value })}
                                        >
                                            {l.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {form.avatar.lentes !== 'ninguno' && form.avatar.lentes !== 'eyepatch' && (
                                <div className="cs-label">
                                    Color de lentes
                                    <ColorRow value={form.avatar.lentes_color} quick={QUICK_LENTES} onChange={(c) => setAvatar({ lentes_color: c })} label="Color lentes" />
                                </div>
                            )}
                            </>)}

                            {creatorSection === 'cuerpo' && (<>
                            <div className="cs-label">
                                Prenda
                                <div className="cs-chip-options">
                                    {ATUENDOS.map((at) => (
                                        <button
                                            key={at.value}
                                            type="button"
                                            className={`cs-chip-btn${form.avatar.atuendo === at.value ? ' active' : ''}`}
                                            onClick={() => setAvatar({ atuendo: at.value })}
                                        >
                                            {at.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {['remera', 'remera_v', 'manga_larga', 'conjunto'].includes(form.avatar.atuendo) && (
                                <div className="cs-label">
                                    Patrón
                                    <div className="cs-chip-options">
                                        {PATRONES.map((pt) => (
                                            <button
                                                key={pt.value}
                                                type="button"
                                                className={`cs-chip-btn${form.avatar.patron === pt.value ? ' active' : ''}`}
                                                onClick={() => setAvatar({ patron: pt.value })}
                                            >
                                                {pt.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className="cs-label">
                                Color principal
                                <ColorRow value={form.avatar.camiseta} quick={QUICK_COLOR} onChange={(c) => setAvatar({ camiseta: c })} label="Color principal" />
                            </div>

                            <div className="cs-label">
                                Color secundario <span className="cs-label-hint">(patrón / detalles)</span>
                                <ColorRow value={form.avatar.color2} quick={QUICK_COLOR} onChange={(c) => setAvatar({ color2: c })} label="Color secundario" />
                            </div>

                            <div className="cs-label">
                                Short
                                <ColorRow value={form.avatar.short_color} quick={QUICK_COLOR} onChange={(c) => setAvatar({ short_color: c })} label="Short" />
                            </div>

                            <div className="cs-label">
                                Medias
                                <ColorRow value={form.avatar.medias} quick={QUICK_COLOR} onChange={(c) => setAvatar({ medias: c })} label="Medias" />
                            </div>

                            <div className="cs-label">
                                Botines
                                <ColorRow value={form.avatar.botines} quick={QUICK_BOTIN} onChange={(c) => setAvatar({ botines: c })} label="Botines" />
                            </div>

                            <div className="cs-label">
                                Estilo de botines
                                <div className="cs-chip-options">
                                    {BOTIN_ESTILOS.map((b) => (
                                        <button
                                            key={b.value}
                                            type="button"
                                            className={`cs-chip-btn${form.avatar.botin_estilo === b.value ? ' active' : ''}`}
                                            onClick={() => setAvatar({ botin_estilo: b.value })}
                                        >
                                            {b.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="cs-label">
                                Accesorio
                                <div className="cs-chip-options">
                                    {ACCESORIOS.map((ac) => (
                                        <button
                                            key={ac.value}
                                            type="button"
                                            className={`cs-chip-btn${form.avatar.accesorio === ac.value ? ' active' : ''}`}
                                            onClick={() => setAvatar({ accesorio: ac.value })}
                                        >
                                            {ac.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {form.avatar.accesorio !== 'ninguno' && (
                                <div className="cs-label">
                                    Color del accesorio
                                    <ColorRow value={form.avatar.accesorio_color} quick={QUICK_COLOR} onChange={(c) => setAvatar({ accesorio_color: c })} label="Color accesorio" />
                                </div>
                            )}
                            </>)}

                            <button className="cs-btn cs-btn-primary" type="submit" disabled={loadingAction}>
                                {loadingAction ? 'Creando...' : 'Crear personaje'}
                            </button>
                        </div>
                    </form>
                </div>
            )}

            {step === 'elegir_club' && (
                <div className="cs-card cs-narrow">
                    <h1 className="cs-title">ELEGÍ TU PRIMER CLUB</h1>
                    <p className="cs-subtitle">
                        {getFlagUrl(career?.nacionalidad) && (
                            <img className="cs-flag cs-flag-inline" src={getFlagUrl(career.nacionalidad)} alt={career.nacionalidad} />
                        )}
                        {career?.nombre} · {career?.nacionalidad} · {career?.posicion} · Rating {career?.rating}
                    </p>
                    <p className="cs-hint">Estas son tus 3 opciones para arrancar tu carrera. Elegí una para continuar.</p>
                    <div className="cs-club-options">
                        {clubOptions.map((club) => (
                            <div className="cs-club-card" key={`${club.pais}-${club.division}-${club.tm_id}`}>
                                <ClubCrest logo={club.logo} nombre={club.nombre} />
                                <div className="cs-club-info">
                                    <div className="cs-club-name">{club.nombre}</div>
                                    <div className="cs-club-meta">{club.liga_nombre} · {club.pais} · D{club.division}</div>
                                    <StarRating value={club.estrellas} />
                                </div>
                                <button
                                    className="cs-btn cs-btn-primary cs-btn-elegir"
                                    onClick={() => handleChooseClub(club)}
                                    disabled={loadingAction}
                                >
                                    Elegir
                                </button>
                            </div>
                        ))}
                    </div>

                    {isAdmin && (
                        <button
                            type="button"
                            className="cs-btn cs-btn-secondary cs-btn-admin-club"
                            onClick={() => setShowAdminClubPicker(true)}
                            disabled={loadingAction}
                        >
                            🛠️ Admin: ir a cualquier club
                        </button>
                    )}
                </div>
            )}

            {step === 'dashboard' && career && (() => {
                // Si el jugador pasó de Libertadores a Sudamericana (o viceversa) entre
                // copas CONMEBOL, su club sigue figurando en los "clubs" de ambas (por el
                // cruce de eliminatorias), así que no alcanza con chequear presencia: hay
                // que priorizar la copa que el jugador efectivamente sigue jugando.
                const euroOptions = [euroStandings.champions, euroStandings.europa, euroStandings.libertadores, euroStandings.sudamericana]
                    .filter(Boolean);
                const euroData = euroOptions.find((e) => e.competicion === nextEuro?.competicion)
                    || euroOptions.find((e) => e.jugador_vivo)
                    || euroOptions.find((e) => e.competicion === career.ultima_copa)
                    || euroOptions[0]
                    || null;
                const inEuro = !!euroData;
                // ¿El próximo avance es un partido europeo del jugador? Si lo es, los botones de
                // simular juegan ESE partido (no la jornada de liga, que viene después).
                const proximoEsEuro = !!career.proximo_turno_es_euro && !!nextEuro;
                const COPA_TXT = { champions: 'Champions', europa: 'Europa League', libertadores: 'Libertadores', sudamericana: 'Sudamericana' };
                const copaTxt = COPA_TXT[nextEuro?.competicion] || 'Copa';
                // seleccionNext se calcula más abajo (antes del return); para los labels lo anticipamos.
                const _selNext = getSeleccionNext(career);
                // ¿Se está jugando el Mundial del jugador (mitad del año 4)?
                const _mundialJugador = career.seleccion?.mundial && (career.seleccion.mundial.fase === 'grupos' || career.seleccion.mundial.fase === 'ko' || career.seleccion.mundial.fase === 'eliminado_espectador');
                const labelRapido = _mundialJugador ? '⚡ Jugar Mundial (Rápido)' : _selNext ? '⚡ Jugar Selección (Rápido)' : proximoEsEuro ? `⚡ Jugar ${copaTxt} (Rápido)` : '⚡ Simular Jornada (Rápido)';
                const labelLento = _mundialJugador ? '🐢 Jugar Mundial (Lento)' : _selNext ? '🐢 Jugar Selección (Lento)' : proximoEsEuro ? `🐢 Jugar ${copaTxt} (Lento)` : '🐢 Simular Jornada (Lento)';
                // Versiones cortas para mobile (CSS muestra una u otra según el ancho).
                const labelRapidoCorto = _mundialJugador ? '⚡ Mundial' : _selNext ? '⚡ Selección' : proximoEsEuro ? `⚡ ${copaTxt}` : '⚡ Rápido';
                const labelLentoCorto = _mundialJugador ? '🐢 Mundial' : _selNext ? '🐢 Selección' : proximoEsEuro ? `🐢 ${copaTxt}` : '🐢 Lento';

                // Tablas (copa + liga) como JSX reutilizable: en PC van en sus columnas del grid;
                // en móvil se renderiza una copia dentro de cs-main que el switch alterna con los
                // "Últimos resultados".
                const euroStandingsJsx = inEuro ? (
                    <Colapsable titulo={`${copaIcon(euroData.competicion)} ${euroData.nombre}`} extra={euroData.fase && (
                        <div className={`cs-euro-phase${euroData.es_campeon ? ' cs-euro-phase--champ' : ''}`}>
                            {euroData.fase === 'grupos' && (
                                euroData.formato === 'grupos'
                                    ? (euroData.competicion === 'libertadores'
                                        ? '📋 Fase de grupos. 1º y 2º → octavos. 3º baja a Sudamericana.'
                                        : '📋 Fase de grupos. 1º → octavos. 2º juega 16avos vs un 3º de Libertadores.')
                                    : '📋 Fase de liga. Top 8 → octavos directo, 9-24 → playoff de 16avos.'
                            )}
                            {euroData.fase === 'knockout' && (
                                <>🔥 {KO_RONDA_LABEL[euroData.ko_ronda] || euroData.ko_ronda} — {euroData.jugador_vivo ? 'tu equipo sigue ✅' : 'tu equipo fue eliminado ❌'}</>
                            )}
                            {euroData.fase === 'finalizado' && (
                                euroData.es_campeon ? '🏆 ¡Tu equipo es el CAMPEÓN!' : `🏆 Campeón: ${euroData.tabla.find((c) => c.tm_id === euroData.campeon_tm_id)?.nombre || '—'}`
                            )}
                        </div>
                    )}>
                        {euroData.fase === 'grupos'
                            ? (euroData.formato === 'grupos'
                                ? <ConmebolGroups data={euroData} careerTmId={career.club_actual?.tm_id} />
                                : <StandingsTable data={euroData} view={euroData.competicion} careerTmId={career.club_actual?.tm_id} />)
                            : <EuroBracket data={euroData} careerTmId={career.club_actual?.tm_id} />}
                    </Colapsable>
                ) : null;
                const ligaStandingsJsx = standings ? (
                    <Colapsable titulo={`Tabla — ${standings.nombre}`}>
                        <StandingsTable data={standings} view="liga" careerTmId={career.club_actual?.tm_id} />
                    </Colapsable>
                ) : null;

                // ── Tabla / bracket de SELECCIÓN para la columna de tablas ──
                const selRef = seleccionDelJugador(career);
                const sEstado = career.seleccion;
                const seleccionNext = getSeleccionNext(career);
                const renderSelTabla = (tabla, paisJ, reglas) => (
                    <>
                        <table className="cs-seleccion-tabla">
                            <thead><tr><th>#</th><th>País</th><th>PJ</th><th>PG</th><th>PE</th><th>PP</th><th>GF</th><th>GC</th><th>Pts</th></tr></thead>
                            <tbody>
                                {tabla.map((t, i) => (
                                    <tr key={t.pais} className={`${t.pais === paisJ ? 'mio ' : ''}${clasifPosClass(reglas, i + 1)}`}>
                                        <td>{i + 1}</td>
                                        <td>{getFlagUrl(t.pais) && <img className="cs-flag cs-flag-inline" src={getFlagUrl(t.pais)} alt={t.pais} />}{t.nombre || t.pais}</td>
                                        <td>{t.pj}</td><td>{t.pg}</td><td>{t.pe}</td><td>{t.pp}</td><td>{t.gf}</td><td>{t.gc}</td><td>{t.pts}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {reglas && (
                            <div className="cs-seleccion-leyenda">
                                <span className="cs-ley-dot sel-q" /> Clasifica &nbsp;
                                {reglas.po?.length > 0 && (<><span className="cs-ley-dot sel-po" /> Repechaje &nbsp;</>)}
                                <span className="cs-ley-txt">{reglas.texto}</span>
                            </div>
                        )}
                    </>
                );
                // Tabla de los SEGUNDOS (o terceros) de cada grupo de la clasificatoria, para explicar
                // el repechaje: se ordenan y se resaltan los N mejores que van al repechaje.
                const renderRepechajeTabla = (grupos, paisJ, repechaje) => {
                    if (!repechaje) return null;
                    const idx = repechaje.cual === 'terceros' ? 2 : 1;
                    const filas = (grupos || [])
                        .map((g) => {
                            const t = ordenarStandingsSel(g.standings);
                            return t[idx] ? { ...t[idx], grupo: g.letra || String.fromCharCode(65 + g.indice) } : null;
                        })
                        .filter(Boolean)
                        .sort((a, b) => (b.pts - a.pts) || ((b.gf - b.gc) - (a.gf - a.gc)) || (b.gf - a.gf));
                    if (filas.length === 0) return null;
                    const titulo = repechaje.cual === 'terceros' ? 'Terceros de cada grupo' : 'Segundos de cada grupo';
                    return (
                        <div style={{ marginTop: 10 }}>
                            <div className="cs-seleccion-h3" style={{ margin: '2px 0 6px' }}>{titulo}</div>
                            <table className="cs-seleccion-tabla">
                                <thead><tr><th>#</th><th>País</th><th>Gr</th><th>PJ</th><th>GF</th><th>GC</th><th>Pts</th></tr></thead>
                                <tbody>
                                    {filas.map((t, i) => (
                                        <tr key={t.pais} className={`${t.pais === paisJ ? 'mio ' : ''}${i < repechaje.n ? 'sel-po' : ''}`}>
                                            <td>{i + 1}</td>
                                            <td>{getFlagUrl(t.pais) && <img className="cs-flag cs-flag-inline" src={getFlagUrl(t.pais)} alt={t.pais} />}{t.nombre || t.pais}</td>
                                            <td>{t.grupo}</td><td>{t.pj}</td><td>{t.gf}</td><td>{t.gc}</td><td>{t.pts}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="cs-seleccion-leyenda">
                                <span className="cs-ley-dot sel-po" /> Va al repechaje (mejores {repechaje.n}) {repechaje.sub || ''}
                            </div>
                        </div>
                    );
                };
                // Tabla de los 12 terceros de los grupos del Mundial: los 8 mejores pasan a 16avos.
                // `grupos` = array con .standings y .indice/.letra. Se ordena igual que el motor.
                const renderTercerosTabla = (grupos, paisJ) => {
                    const terceros = (grupos || [])
                        .map((g) => {
                            const t = ordenarStandingsSel(g.standings);
                            return t[2] ? { ...t[2], grupo: g.letra || String.fromCharCode(65 + g.indice) } : null;
                        })
                        .filter(Boolean)
                        .sort((a, b) => (b.pts - a.pts) || ((b.gf - b.gc) - (a.gf - a.gc)) || (b.gf - a.gf));
                    if (terceros.length === 0) return null;
                    return (
                        <div style={{ marginTop: 10 }}>
                            <div className="cs-seleccion-h3" style={{ margin: '2px 0 6px' }}>🥉 Mejores terceros (8 pasan a 16avos)</div>
                            <table className="cs-seleccion-tabla">
                                <thead><tr><th>#</th><th>País</th><th>Gr</th><th>PJ</th><th>GF</th><th>GC</th><th>Pts</th></tr></thead>
                                <tbody>
                                    {terceros.map((t, i) => (
                                        <tr key={t.pais} className={`${t.pais === paisJ ? 'mio ' : ''}${i < 8 ? 'sel-q' : ''}`}>
                                            <td>{i + 1}</td>
                                            <td>{getFlagUrl(t.pais) && <img className="cs-flag cs-flag-inline" src={getFlagUrl(t.pais)} alt={t.pais} />}{t.nombre || t.pais}</td>
                                            <td>{t.grupo}</td>
                                            <td>{t.pj}</td><td>{t.gf}</td><td>{t.gc}</td><td>{t.pts}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="cs-seleccion-leyenda">
                                <span className="cs-ley-dot sel-q" /> Pasa a 16avos (8 mejores terceros)
                            </div>
                        </div>
                    );
                };
                let seleccionStandingsJsx = null;
                if (selRef && sEstado) {
                    const m = sEstado.mundial;
                    const esp = sEstado.mundial_espectador;
                    const reglasConf = CLASIF_RULES[sEstado.confederacion];
                    let faseTxt = '';
                    let cuerpo = null;
                    if (esp) {
                        // No clasificaste: ves el Mundial avanzar paso a paso (grupos → KO → campeón).
                        const nom = (p) => SELECCIONES_BY_PAIS[p]?.nombre || p || '—';
                        const RLko = { '16avos': '16avos', octavos: 'Octavos', cuartos: 'Cuartos', semis: 'Semifinal', final: 'Final' };
                        faseTxt = esp.fase === 'grupos'
                            ? `🌍 Mundial · Grupos (fecha ${Math.min(esp.fechaActual, 3)}/3)`
                            : esp.fase === 'finalizado' ? '🌍 Mundial · Finalizado' : `🌍 Mundial · ${RLko[esp.ko_ronda] || esp.ko_ronda}`;
                        cuerpo = (
                            <div className="cs-seleccion-ko">
                                <div className="cs-seleccion-proximo" style={{ opacity: 0.75 }}>No clasificaste — seguí el Mundial. Avanzá para ver cómo sigue.</div>
                                {esp.campeon && (
                                    <div className="cs-seleccion-proximo" style={{ color: '#facc15', fontWeight: 800 }}>
                                        🏆 Campeón: {getFlagUrl(esp.campeon) && <img className="cs-flag cs-flag-inline" src={getFlagUrl(esp.campeon)} alt="" />}{nom(esp.campeon)}
                                        {esp.subcampeon ? ` · 🥈 ${nom(esp.subcampeon)}` : ''}
                                    </div>
                                )}
                                {esp.fase === 'grupos' && esp.fechaActual > 0 && (
                                    <div className="cs-seleccion-esp-grupos">
                                        {esp.grupos.map((g) => {
                                            const t = ordenarStandingsSel(g.standings);
                                            return (
                                                <div key={g.indice} className="cs-esp-grupo">
                                                    <div className="cs-esp-grupo-tit">Grupo {g.letra || (g.indice + 1)}</div>
                                                    {t.map((row, i) => (
                                                        <div key={row.pais} className={`cs-esp-row${i < 2 ? ' sel-q' : i === 2 ? ' sel-po' : ''}`}>
                                                            <span>{i + 1}. {getFlagUrl(row.pais) && <img className="cs-flag cs-flag-inline" src={getFlagUrl(row.pais)} alt="" />}{nom(row.pais)}</span>
                                                            <b>{row.pts}</b>
                                                        </div>
                                                    ))}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                                {((esp.ko_rondas || []).length > 0 || (esp.ko_vivos || []).length > 0) && (
                                    <>
                                        <div className="cs-seleccion-h3" style={{ margin: '10px 0 6px' }}>Cuadro del Mundial</div>
                                        <BracketSel rondas={buildFullKOBracket(esp.ko_rondas, esp.ko_vivos)} paisJ={sEstado.pais} />
                                    </>
                                )}
                                {esp.fase !== 'grupos' && renderTercerosTabla(esp.grupos, sEstado.pais)}
                            </div>
                        );
                    } else if (m && (m.fase === 'grupos' || m.fase === 'ko' || m.fase === 'eliminado_espectador' || m.fase === 'finalizado')) {
                        if (m.fase === 'grupos' && m.grupoJugadorIdx >= 0) {
                            faseTxt = '🌍 Mundial · Fase de grupos';
                            cuerpo = renderSelTabla(ordenarStandingsSel(m.grupos[m.grupoJugadorIdx].standings), sEstado.pais, MUNDIAL_GRUPO_RULES);
                        } else {
                            faseTxt = m.fase === 'finalizado' ? '🌍 Mundial · Final'
                                : m.fase === 'eliminado_espectador' ? '🌍 Mundial · Quedaste afuera — mirá cómo termina'
                                    : `🌍 Mundial · ${KO_RONDA_LABEL[m.ko_ronda] || m.ko_ronda}`;
                            // Camino del jugador estilo bracket: fase de grupos (3 partidos) + cada ronda KO.
                            const pj = m.partidosJugador || [];
                            const grupoMatches = pj.filter((p) => p.tipo === 'grupo');
                            const koMatches = pj.filter((p) => p.tipo === 'ko');
                            const rondas = [];
                            if (grupoMatches.length) {
                                rondas.push({
                                    titulo: 'Fase de grupos',
                                    partidos: grupoMatches.map((p) => ({ a: sEstado.pais, b: p.rival_pais, gh: p.gf, ga: p.gc, ganador: p.gf > p.gc ? sEstado.pais : p.gf < p.gc ? p.rival_pais : null })),
                                });
                            }
                            for (const p of koMatches) {
                                rondas.push({
                                    titulo: KO_RONDA_LABEL[p.ronda] || p.ronda,
                                    partidos: [{ a: sEstado.pais, b: p.rival_pais, gh: p.gf, ga: p.gc, penales: p.penales, ganador: p.gf > p.gc ? sEstado.pais : p.rival_pais }],
                                });
                            }
                            // Cuadro KO COMPLETO (estilo Champions): todas las rondas con espacios en
                            // blanco que se completan a medida que ganan los equipos.
                            const hayKO = (m.ko_rondas || []).length > 0 || (m.ko_vivos || []).length > 0;
                            const cuadroFull = hayKO ? buildFullKOBracket(m.ko_rondas, m.ko_vivos) : [];
                            cuerpo = (
                                <>
                                    {m.campeon_pais && <div className="cs-seleccion-proximo" style={{ color: '#facc15', fontWeight: 800, marginBottom: 6 }}>🏆 Campeón: {getFlagUrl(m.campeon_pais) && <img className="cs-flag cs-flag-inline" src={getFlagUrl(m.campeon_pais)} alt="" />}{SELECCIONES_BY_PAIS[m.campeon_pais]?.nombre || m.campeon_pais}</div>}
                                    {rondas.length > 0 && (
                                        <>
                                            <div className="cs-seleccion-h3" style={{ margin: '2px 0 6px' }}>Tu camino</div>
                                            <BracketSel rondas={rondas} paisJ={sEstado.pais} />
                                        </>
                                    )}
                                    {cuadroFull.length > 0 && (
                                        <>
                                            <div className="cs-seleccion-h3" style={{ margin: '12px 0 6px' }}>Cuadro del Mundial</div>
                                            <BracketSel rondas={cuadroFull} paisJ={sEstado.pais} />
                                        </>
                                    )}
                                    {rondas.length === 0 && cuadroFull.length === 0 && <div className="cs-seleccion-proximo">El cuadro se va a ir armando partido a partido.</div>}
                                    {renderTercerosTabla(m.grupos, sEstado.pais)}
                                </>
                            );
                        }
                    } else if (sEstado.fase === 'eliminado') {
                        faseTxt = '🌍 Selección · Eliminado';
                        cuerpo = (
                            <div className="cs-seleccion-afuera">
                                ❌ Tu selección quedó <b>afuera del Mundial</b>.
                                <div className="cs-seleccion-afuera-sub">No jugás más con la selección hasta las próximas clasificatorias (próximo ciclo).</div>
                            </div>
                        );
                    } else if (sEstado.fase === 'playoff' && sEstado.playoff) {
                        const po = sEstado.playoff;
                        faseTxt = '🌍 Repechaje Mundial';
                        const rondasPO = po.ties.map((t) => ({
                            titulo: t.leg === 'ida' ? 'Repechaje · Ida' : t.leg === 'vuelta' ? 'Repechaje · Vuelta' : 'Repechaje',
                            partidos: [{
                                a: t.leg === 'vuelta' ? t.rival_pais : sEstado.pais,
                                b: t.leg === 'vuelta' ? sEstado.pais : t.rival_pais,
                                gh: t.jugado ? (t.leg === 'vuelta' ? t.gc : t.gf) : null,
                                ga: t.jugado ? (t.leg === 'vuelta' ? t.gf : t.gc) : null,
                                ganador: t.jugado ? (t.gf > t.gc ? sEstado.pais : t.rival_pais) : null,
                            }],
                        }));
                        cuerpo = (
                            <>
                                <div className="cs-seleccion-proximo" style={{ marginBottom: 6 }}>Llave a ida y vuelta vs <b>{po.rival_nombre || po.ties?.[0]?.rival_nombre}</b> por el último cupo. Global {po.agg_favor || 0}-{po.agg_contra || 0}.</div>
                                <BracketSel rondas={rondasPO} paisJ={sEstado.pais} />
                                <div className="cs-seleccion-proximo" style={{ opacity: 0.8, marginTop: 6 }}>Ganás por global → Mundial. Perdés → afuera.</div>
                            </>
                        );
                    } else if (sEstado.fase === 'preplayoff' && sEstado.preplayoff) {
                        const pp = sEstado.preplayoff;
                        faseTxt = '🌍 Pre-repechaje CONCACAF';
                        const rondasPP = pp.ties.map((t) => ({
                            titulo: t.ronda,
                            partidos: [{
                                a: sEstado.pais, b: t.rival_pais,
                                gh: t.jugado ? t.gf : null, ga: t.jugado ? t.gc : null,
                                ganador: t.jugado ? (t.gf > t.gc ? sEstado.pais : t.rival_pais) : null,
                            }],
                        }));
                        cuerpo = (
                            <>
                                <div className="cs-seleccion-proximo" style={{ marginBottom: 6 }}>Sos del bombo 4: pasá 2 rondas para entrar a la fase de grupos.</div>
                                <BracketSel rondas={rondasPP} paisJ={sEstado.pais} />
                            </>
                        );
                    } else if (sEstado.fase === 'clasificado') {
                        const grupoJ = sEstado.grupos?.[sEstado.grupoJugadorIdx];
                        faseTxt = '🌍 ✅ Clasificado al Mundial';
                        cuerpo = (
                            <>
                                <div className="cs-seleccion-proximo" style={{ color: '#4ade80', fontWeight: 800, marginBottom: 8 }}>¡Tu selección jugará el próximo Mundial!</div>
                                {grupoJ && renderSelTabla(ordenarStandingsSel(grupoJ.standings), sEstado.pais, reglasConf)}
                                {renderRepechajeTabla(sEstado.grupos, sEstado.pais, reglasConf?.repechaje)}
                            </>
                        );
                    } else {
                        const grupoJ = sEstado.grupos?.[sEstado.grupoJugadorIdx];
                        faseTxt = `🌍 Eliminatorias · Año ${sEstado.año_ciclo}/4`;
                        cuerpo = (
                            <>
                                {reglasConf?.detalle && <div className="cs-seleccion-proximo" style={{ opacity: 0.85, marginBottom: 8 }}>ℹ️ {reglasConf.detalle}</div>}
                                {grupoJ && renderSelTabla(ordenarStandingsSel(grupoJ.standings), sEstado.pais, reglasConf)}
                                {renderRepechajeTabla(sEstado.grupos, sEstado.pais, reglasConf?.repechaje)}
                            </>
                        );
                    }
                    seleccionStandingsJsx = (
                        <Colapsable titulo={faseTxt} extra={selRef && (
                            <div className="cs-seleccion-sub" style={{ marginBottom: 8 }}>{selRef.nombre} · {'★'.repeat(Math.floor(selRef.estrellas))}{selRef.estrellas % 1 ? '½' : ''} · FIFA #{selRef.ranking}</div>
                        )}>
                            {cuerpo}
                        </Colapsable>
                    );
                }
                // Mientras se juega el Mundial (jugador o espectador), mostramos SOLO la tabla del
                // Mundial y ocultamos las del club (liga + copa continental).
                const mundialEnPantalla = !!(career.seleccion?.mundial && career.seleccion.mundial.fase !== 'finalizado')
                    || !!(career.seleccion?.mundial_espectador && career.seleccion.mundial_espectador.fase !== 'finalizado');
                const euroTablaJsx = mundialEnPantalla ? null : euroStandingsJsx;
                const ligaTablaJsx = mundialEnPantalla ? null : ligaStandingsJsx;
                // Durante el Mundial: layout de 2 columnas (partido | tabla del Mundial). Si no,
                // 3 columnas cuando hay copa/selección, o 2 normales.
                const showCopaCol = !mundialEnPantalla && (inEuro || !!seleccionStandingsJsx);

                // En MOBILE, en vez de apilar las 3 tablas, un submenu para elegir cuál ver.
                const tablasMobile = [];
                if (seleccionStandingsJsx) tablasMobile.push({ key: 'seleccion', label: '🌍 Selección', jsx: seleccionStandingsJsx });
                if (euroTablaJsx) tablasMobile.push({ key: 'copa', label: `${copaIcon(euroData?.competicion)} Copa`, jsx: euroTablaJsx });
                if (ligaTablaJsx) tablasMobile.push({ key: 'liga', label: '🏆 Liga', jsx: ligaTablaJsx });
                const tablaMobileActiva = tablasMobile.find((t) => t.key === mobileTablaSel) || tablasMobile[0];

                return (
                <div className={`cs-dashboard${showCopaCol ? ' cs-dashboard--euro' : ''} cs-dashboard--mtab-${mobileTab}${seleccionNext ? ' cs-dashboard--seleccion' : ''}`}>
                    <header className="cs-player-card cs-panel">
                        <div className="cs-player-avatar">
                            <PlayerAvatar avatar={career.avatar} size={64} altura={career.altura} peso={career.peso} />
                        </div>
                        <div className="cs-rating-badge">
                            <span className="cs-rating-num">{career.rating}</span>
                            <span className="cs-rating-pos">{POSITION_ABBR[career.posicion] || career.posicion}</span>
                        </div>
                        <div className="cs-player-identity">
                            <h1 className="cs-player-name">{career.nombre}</h1>
                            <div className="cs-player-meta">
                                {getFlagUrl(career.nacionalidad) && (
                                    <img className="cs-flag cs-flag-inline" src={getFlagUrl(career.nacionalidad)} alt={career.nacionalidad} />
                                )}
                                <span>{career.nacionalidad}</span>
                                <span className="cs-meta-sep">·</span>
                                <span>{career.edad} años</span>
                                <span className="cs-meta-sep">·</span>
                                <span>Temporada {career.temporada}</span>
                                {MES_NOMBRES[career.mes] && (
                                    <>
                                        <span className="cs-meta-sep">·</span>
                                        <span>{MES_NOMBRES[career.mes]}</span>
                                    </>
                                )}
                                {career.valor_mercado > 0 && (
                                    <>
                                        <span className="cs-meta-sep">·</span>
                                        <span>💰 ${career.valor_mercado}M</span>
                                    </>
                                )}
                                {career.stats_temporada && (
                                    <>
                                        <span className="cs-meta-sep">·</span>
                                        <span title="Goles y asistencias en la temporada actual">
                                            ⚽ {career.stats_temporada.goles ?? 0} · 🅰️ {career.stats_temporada.asistencias ?? 0}
                                        </span>
                                    </>
                                )}
                                {career.contrato_restante > 0 && (
                                    <>
                                        <span className="cs-meta-sep">·</span>
                                        <span title="Temporadas que quedan de contrato">
                                            📝 {career.contrato_restante} {career.contrato_restante === 1 ? 'año' : 'años'}
                                        </span>
                                    </>
                                )}
                                {career.suspendido_jornadas > 0 && (
                                    <>
                                        <span className="cs-meta-sep">·</span>
                                        <span className="cs-suspendido">🟥 Suspendido {career.suspendido_jornadas}j</span>
                                    </>
                                )}
                            </div>
                            <button
                                type="button"
                                className="cs-logros-chip"
                                onClick={() => { setShowLogrosModal(true); refreshLogros(); }}
                                title="Logros conseguidos entre todas tus carreras"
                            >
                                🏆 Logros {logrosData?.unlocked?.length ? <strong>{logrosData.unlocked.length}/{LOGROS.length}</strong> : `0/${LOGROS.length}`}
                            </button>
                            {(() => {
                                const sel = seleccionDelJugador(career);
                                if (!sel) return null;
                                const conv = isCalledUpSeleccion(career, sel);
                                return (
                                    <button
                                        type="button"
                                        className={`cs-seleccion-chip${conv ? '' : ' cs-seleccion-chip--off'}`}
                                        onClick={() => setShowSeleccionModal(true)}
                                        title={conv ? 'Convocado a la selección' : 'El DT todavía no te considera apto para convocarte a tu selección'}
                                    >
                                        🌍 {sel.nombre} {conv ? '⭐' : '🚫'}
                                    </button>
                                );
                            })()}
                        </div>
                        {career.club_actual && (
                            <div className="cs-player-club">
                                <ClubCrest logo={career.club_actual.logo} nombre={career.club_actual.nombre} />
                                <div className="cs-club-info">
                                    <div className="cs-club-name">{career.club_actual.nombre}</div>
                                    <div className="cs-club-meta">
                                        {career.club_actual.pais} · D{career.club_actual.division}
                                    </div>
                                    <StarRating value={career.club_actual.estrellas} />
                                </div>
                            </div>
                        )}
                    </header>

                    <section className="cs-main">
                        {seleccionNext && (
                            <div className="cs-next-seleccion cs-panel">
                                <div className="cs-next-seleccion-label">
                                    <span className="cs-turno-tag cs-turno-tag--sel">SELECCIÓN · AHORA</span>
                                    🌍 {seleccionNext.instancia}
                                </div>
                                <div className="cs-next-seleccion-match">
                                    <span className="cs-next-seleccion-team">
                                        {getFlagUrl(career.nacionalidad) && <img className="cs-flag" src={getFlagUrl(career.nacionalidad)} alt={career.nacionalidad} />}
                                        {career.nacionalidad}
                                    </span>
                                    <span className="cs-next-seleccion-vs">{seleccionNext.local ? 'vs' : '@'}</span>
                                    <span className="cs-next-seleccion-team">
                                        {getFlagUrl(seleccionNext.rival_pais) && <img className="cs-flag" src={getFlagUrl(seleccionNext.rival_pais)} alt={seleccionNext.rival_pais} />}
                                        {seleccionNext.rival_nombre}
                                    </span>
                                </div>
                                {!seleccionNext.convocado && <div className="cs-next-seleccion-note">🚫 El DT no te consideró apto para esta convocatoria: tu selección juega sin vos.</div>}
                            </div>
                        )}

                        {nextMatch && !seleccionNext && (
                            <div className={`cs-next-match cs-panel${proximoEsEuro ? ' cs-next-match--later' : ''}`}>
                                <div className="cs-next-match-label">
                                    {proximoEsEuro && <span className="cs-turno-tag">DESPUÉS</span>}
                                    Jornada {nextMatch.jornada} · {nextMatch.esLocal ? 'Local' : 'Visitante'}
                                </div>
                                <div className="cs-next-match-teams">
                                    <div className="cs-next-match-team">
                                        <ClubCrest logo={nextMatch.home?.logo} nombre={nextMatch.home?.nombre} />
                                        <span>{nextMatch.home?.nombre || 'Libre'}</span>
                                    </div>
                                    <span className="cs-next-match-vs">vs</span>
                                    <div className="cs-next-match-team">
                                        <ClubCrest logo={nextMatch.away?.logo} nombre={nextMatch.away?.nombre} />
                                        <span>{nextMatch.away?.nombre || 'Libre'}</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {nextEuro && !seleccionNext && (
                            <div className={`cs-next-euro cs-panel${nextEuro.knockout ? ' cs-next-euro--ko' : ''}${proximoEsEuro ? ' cs-next-euro--now' : ''}`}>
                                <div className="cs-next-euro-label">
                                    {proximoEsEuro && <span className="cs-turno-tag cs-turno-tag--now">AHORA</span>}
                                    {copaIcon(nextEuro.competicion)} {nextEuro.nombre} · {nextEuro.faseTxt}
                                </div>
                                <div className="cs-next-euro-match">
                                    <ClubCrest logo={nextEuro.rival?.logo} nombre={nextEuro.rival?.nombre} />
                                    <span className="cs-next-euro-rival">{nextEuro.esLocal ? 'vs' : '@'} {nextEuro.rival?.nombre || '—'}</span>
                                </div>
                                {nextEuro.idaResultado && (
                                    <div className="cs-next-euro-ida">🔁 Ida: <b>{nextEuro.idaResultado.favor}-{nextEuro.idaResultado.contra}</b></div>
                                )}
                                {nextEuro.knockout && (
                                    <div className="cs-next-euro-note">⏸ El modo automático se detiene en partidos de eliminatoria.</div>
                                )}
                            </div>
                        )}

                        {/* Switch solo en móvil: alterna lo que se muestra abajo (últimos resultados o
                            la tabla). El resto (moral, pizarra, jornada, acciones) queda visible siempre. */}
                        <div className="cs-mobile-switch">
                            <button
                                type="button"
                                className={`cs-mswitch-btn${mobileTab === 'estado' ? ' active' : ''}`}
                                onClick={() => setMobileTab('estado')}
                            >
                                📋 Resultados
                            </button>
                            <button
                                type="button"
                                className={`cs-mswitch-btn${mobileTab === 'tablas' ? ' active' : ''}`}
                                onClick={() => setMobileTab('tablas')}
                            >
                                📊 Tablas
                            </button>
                        </div>

                        {/* Estado del jugador: moral + plan de partido (charla táctica) con el que encarás
                            el próximo partido. El plan mueve el resultado de todo el equipo según el rival. */}
                        <div className="cs-estado cs-panel">
                            <div className="cs-moral-row">
                                <span className="cs-moral-label">😤 Moral</span>
                                <div className="cs-moral-bar">
                                    <div
                                        className="cs-moral-fill"
                                        style={{
                                            width: `${career.moral ?? 60}%`,
                                            background: (career.moral ?? 60) >= 66 ? '#22c55e' : (career.moral ?? 60) >= 40 ? '#facc15' : '#ef4444',
                                        }}
                                    />
                                </div>
                                <span className="cs-moral-val">{career.moral ?? 60}</span>
                            </div>

                            {(() => {
                                const tac = { ...defaultTacticas(), ...(career.tacticas || {}) };
                                // Scouting parcial del próximo rival REAL (liga, copa o nada si es selección).
                                const sc = proximoScouting();
                                return (
                                    <>
                                        {sc?.pista && <div className="cs-scouting">{sc.pista}{sc.rivalNombre ? ` (${sc.rivalNombre})` : ''}</div>}
                                        <button
                                            type="button"
                                            className="cs-tac-open"
                                            onClick={() => setShowTacticasModal(true)}
                                            disabled={autoMode}
                                        >
                                            <span className="cs-tac-open-main">📋 Pizarra táctica</span>
                                            <span className="cs-tac-open-sub">
                                                {TACTICA_LABEL[tac.formacion]} · {TACTICA_LABEL[tac.actitud]} · {TACTICA_LABEL[tac.presion]}
                                            </span>
                                        </button>
                                    </>
                                );
                            })()}
                        </div>

                        <div className="cs-actions-row">
                            <button
                                className="cs-btn cs-btn-primary cs-btn-advance"
                                onClick={() => handleAdvanceMatchday('rapido')}
                                disabled={loadingAction || temporadaFinalizada || autoMode}
                                title="Simula la jornada al instante, sin animación"
                            >
                                {temporadaFinalizada ? 'Temporada finalizada' : (loadingAction ? 'Simulando...' : (
                                    <><span className="cs-btn-full">{labelRapido}</span><span className="cs-btn-short">{labelRapidoCorto}</span></>
                                ))}
                            </button>
                            <button
                                className="cs-btn cs-btn-primary cs-btn-advance"
                                onClick={() => handleAdvanceMatchday('lento')}
                                disabled={loadingAction || temporadaFinalizada || autoMode}
                                title="Simula la jornada con animación minuto a minuto de tu partido"
                            >
                                {temporadaFinalizada ? 'Temporada finalizada' : (loadingAction ? 'Simulando...' : (
                                    <><span className="cs-btn-full">{labelLento}</span><span className="cs-btn-short">{labelLentoCorto}</span></>
                                ))}
                            </button>
                            <button
                                className={`cs-btn cs-btn-auto${autoMode ? ' cs-btn-auto--active' : ''}`}
                                onClick={() => setAutoMode((a) => !a)}
                                disabled={(loadingAction && !autoMode) || temporadaFinalizada}
                                title="Avanza jornadas automáticamente hasta que termine la temporada o llegue una oferta"
                            >
                                {autoMode
                                    ? '⏸ Detener'
                                    : (<><span className="cs-btn-full">⏩ Simular Automático</span><span className="cs-btn-short">⏩ Auto</span></>)}
                            </button>
                            <button
                                className="cs-btn cs-btn-tactics"
                                onClick={handleOpenAtributosModal}
                                disabled={loadingAction || autoMode}
                            >
                                <span className="cs-btn-full">⚡ ATRIBUTOS</span><span className="cs-btn-short">⚡ Attr</span>
                                {career.puntos_disponibles > 0 ? ` (${career.puntos_disponibles})` : ''}
                            </button>
                        </div>

                        {career.historial_partidos && career.historial_partidos.length > 0 && (
                            <div className="cs-results cs-panel">
                                <div className="cs-results-header">
                                    <h2 className="cs-section-title">Últimos resultados</h2>
                                    <div className="cs-form-guide">
                                        {career.historial_partidos.slice(-5).map((p, idx) => {
                                            const resultado = p.gf > p.gc ? 'G' : p.gf < p.gc ? 'P' : 'E';
                                            return (
                                                <span key={idx} className={`cs-result-tag cs-result-tag--${resultado} cs-result-tag--mini`}>
                                                    {resultado}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div className="cs-results-list">
                                    {[...career.historial_partidos].reverse().map((p, idx) => {
                                        const resultado = p.gf > p.gc ? 'G' : p.gf < p.gc ? 'P' : 'E';
                                        return (
                                            <div className="cs-result-row" key={idx}>
                                                <span className={`cs-result-tag cs-result-tag--${resultado}`}>{resultado}</span>
                                                <span className="cs-result-info">
                                                    {p.competicion && p.competicion !== 'liga' && `${copaIcon(p.competicion)} `}
                                                    {p.local ? 'vs' : '@'} {p.rival_nombre} · {p.gf}-{p.gc}
                                                </span>
                                                <span className="cs-result-stats">
                                                    {p.suspendido ? '🟥 Suspendido' : (
                                                        <>
                                                            {p.minutos_jugados}'
                                                            {p.goles_jugador > 0 && ` · ⚽ ${p.goles_jugador}`}
                                                            {p.asistencias_jugador > 0 && ` · 🅰️ ${p.asistencias_jugador}`}
                                                            {p.amarilla && ' · 🟨'}
                                                            {p.roja && ' · 🟥'}
                                                        </>
                                                    )}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {/* Copia de la tabla SOLO para móvil: el switch la alterna con los
                            "Últimos resultados". Un submenu elige QUÉ tabla ver (no se apilan). */}
                        <div className="cs-tables-mobile">
                            {tablasMobile.length > 1 && (
                                <div className="cs-mtablas-sub">
                                    {tablasMobile.map((t) => (
                                        <button
                                            key={t.key}
                                            type="button"
                                            className={`cs-mtab-btn${tablaMobileActiva?.key === t.key ? ' active' : ''}`}
                                            onClick={() => setMobileTablaSel(t.key)}
                                        >
                                            {t.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                            {tablaMobileActiva?.jsx}
                        </div>

                        {career.historial_stats?.length > 0 && (
                            <div className="cs-career-history cs-panel">
                                <h2 className="cs-section-title">🏆 Carrera</h2>
                                <div className="cs-career-history-list">
                                    {[...career.historial_stats].sort((a, b) => (b.temporada ?? 0) - (a.temporada ?? 0)).map((s) => (
                                        <div className="cs-career-row" key={s.temporada}>
                                            <div className="cs-career-row-head">
                                                <span className="cs-career-row-temp">T{s.temporada}</span>
                                                <span className="cs-career-row-club">{s.club_nombre}</span>
                                                <span className="cs-career-row-pos">{s.posicion_final}º</span>
                                            </div>
                                            <div className="cs-career-row-stats">
                                                {s.partidos} PJ · {s.goles}⚽ · {s.asistencias}🅰️ · Rating {s.rating_final}
                                            </div>
                                            {s.titulos?.length > 0 && (
                                                <div className="cs-career-row-titles">
                                                    {s.titulos.map((t) => <span key={t} className="cs-career-title-pill">🏆 {t}</span>)}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <button className="cs-btn cs-btn-danger" onClick={() => setShowRetireModal(true)} disabled={loadingAction}>
                            🎙️ Retirarse
                        </button>
                    </section>

                    {/* Tablas en PC: van en sus columnas del grid (cs-left = copa, cs-side = liga).
                        En móvil este bloque se oculta; la tabla se muestra como copia dentro de
                        cs-main (cs-tables-mobile), alternada por el switch. */}
                    <div className="cs-tables">
                        <div className="cs-tables-panel">
                            {mundialEnPantalla ? (
                                <aside className="cs-side">{seleccionStandingsJsx}</aside>
                            ) : (
                                <>
                                    {showCopaCol && <aside className="cs-left">{euroTablaJsx}{seleccionStandingsJsx}</aside>}
                                    <aside className="cs-side">{ligaTablaJsx}</aside>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                );
            })()}


            {showAtributosModal && atrDraft && career && (() => {
                const prio = PM.PRIORIDAD[career.posicion] || PM.ATRIBUTOS;
                return (
                <div className="cs-modal-overlay" onClick={() => setShowAtributosModal(false)}>
                    <div className="cs-modal" onClick={(e) => e.stopPropagation()}>
                        <h2 className="cs-section-title">⚡ Atributos · {career.posicion}</h2>

                        <div className="cs-attr-summary">
                            <span>Media <b>{career.rating}</b></span>
                            <span className="cs-attr-puntos">Puntos a asignar: <b>{atrDraft.puntos}</b></span>
                        </div>

                        <div className="cs-attr-list">
                            {prio.map((attr) => {
                                const val = atrDraft.atributos[attr];
                                return (
                                    <div className="cs-attr-row" key={attr}>
                                        <span className="cs-attr-name">{PM.ATRIBUTO_LABEL[attr]}</span>
                                        <div className="cs-attr-bar"><div className="cs-attr-bar-fill" style={{ width: `${val * 10}%` }} /></div>
                                        <button className="cs-attr-btn" onClick={() => ajustarAtributo(attr, -1)} disabled={val <= atrDraft.base[attr]} aria-label="Quitar">−</button>
                                        <span className="cs-attr-val">{val}</span>
                                        <button className="cs-attr-btn" onClick={() => ajustarAtributo(attr, 1)} disabled={atrDraft.puntos <= 0 || val >= 10} aria-label="Sumar">+</button>
                                    </div>
                                );
                            })}
                        </div>

                        <button className="cs-btn cs-btn-secondary cs-attr-reset" onClick={resetearAtributos}>
                            ♻️ Resetear todo (cuesta 1 punto)
                        </button>

                        <div className="cs-modal-actions">
                            <button className="cs-btn cs-btn-secondary" onClick={() => setShowAtributosModal(false)}>Cancelar</button>
                            <button className="cs-btn cs-btn-primary" onClick={guardarAtributos}>Guardar</button>
                        </div>
                    </div>
                </div>
                );
            })()}

            {showLogrosModal && (() => {
                const unlockedMap = {};
                for (const u of (logrosData?.unlocked || [])) unlockedMap[u.key] = u;
                const total = LOGROS.length;
                const conseguidos = (logrosData?.unlocked || []).length;
                const fmtFecha = (f) => { try { return new Date(f).toLocaleDateString('es-AR'); } catch { return ''; } };
                // Progreso de la carrera ACTUAL (se reinicia al empezar otra). Para los logros de
                // "copa con cada país" el progreso es cross-carrera → sale del acumulador del backend.
                let prog = {};
                try { prog = career ? (evaluarLogros(career, {}).progreso || {}) : {}; } catch { prog = {}; }
                const totalConmebol = (logrosData?.paises_conmebol || []).length || 10;
                const totalUefa = (logrosData?.paises_uefa || []).length || 17;
                prog.dificil_liber_cada_pais = { cur: (logrosData?.acc?.libertadores_paises || []).length, target: totalConmebol };
                prog.dificil_sudam_cada_pais = { cur: (logrosData?.acc?.sudamericana_paises || []).length, target: totalConmebol };
                prog.dificil_champ_cada_pais = { cur: (logrosData?.acc?.champions_paises || []).length, target: totalUefa };
                prog.dificil_europa_cada_pais = { cur: (logrosData?.acc?.europa_paises || []).length, target: totalUefa };
                return (
                    <div className="cs-modal-overlay" onClick={() => setShowLogrosModal(false)}>
                        <div className="cs-modal cs-logros-modal" onClick={(e) => e.stopPropagation()}>
                            <div className="cs-logros-head">
                                <h2 className="cs-section-title">🏆 Logros</h2>
                                <span className="cs-logros-count">{conseguidos}/{total}</span>
                            </div>
                            <p className="cs-logros-sub">Se guardan entre todas tus carreras, con la fecha y el club con el que los conseguiste. El progreso de los logros de una sola carrera se reinicia al empezar otra.</p>
                            {TIERS.map((tier) => {
                                const items = LOGROS.filter((l) => l.tier === tier);
                                return (
                                    <div key={tier} className={`cs-logros-tier cs-logros-tier--${tier}`}>
                                        <h3 className="cs-logros-tier-title">{TIER_LABEL[tier]}</h3>
                                        <div className="cs-logros-grid">
                                            {items.map((l) => {
                                                const u = unlockedMap[l.key];
                                                const done = !!u;
                                                const p = prog[l.key];
                                                const pct = (p && p.target) ? Math.min(100, Math.round((p.cur / p.target) * 100)) : 0;
                                                // Selección: la "marca" del logro es la bandera del país (como el escudo del club).
                                                const esSel = l.key.startsWith('sel_');
                                                const crest = esSel ? getFlagUrl(u?.club_nombre) : u?.club_logo;
                                                return (
                                                    <div key={l.key} className={`cs-logro${done ? ' cs-logro--done' : ' cs-logro--locked'}`}>
                                                        <div className="cs-logro-top">
                                                            <span className="cs-logro-ic">{done ? '🏆' : '🔒'}</span>
                                                            <div className="cs-logro-titulo" title={l.titulo}>{l.titulo}</div>
                                                        </div>
                                                        <div className="cs-logro-desc" title={l.desc}>{l.desc}</div>
                                                        <div className="cs-logro-foot">
                                                            {done ? (
                                                                <div className="cs-logro-meta">
                                                                    <span className="cs-logro-where">
                                                                        {crest ? <img src={crest} alt="" className="cs-logro-crest" /> : null}
                                                                        <span className="cs-logro-where-txt">{u.club_nombre || ''}</span>
                                                                    </span>
                                                                    {u.fecha ? <span className="cs-logro-fecha">{fmtFecha(u.fecha)}</span> : null}
                                                                </div>
                                                            ) : p ? (
                                                                p.texto ? (
                                                                    <div className="cs-logro-prog-txt" title={p.texto}>{p.texto}</div>
                                                                ) : (
                                                                    <div className="cs-logro-prog">
                                                                        <div className="cs-logro-prog-bar"><span style={{ width: `${pct}%` }} /></div>
                                                                        <span className="cs-logro-prog-num">{p.cur > p.target ? p.target : p.cur}/{p.target}</span>
                                                                    </div>
                                                                )
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                            <div className="cs-modal-actions">
                                <button className="cs-btn cs-btn-secondary" onClick={() => setShowLogrosModal(false)}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {mundialCallup && (
                <div className="cs-modal-overlay" onClick={() => setMundialCallup(null)}>
                    <div className="cs-modal cs-callup-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="cs-callup-emoji">🎉🌍🎉</div>
                        <h2 className="cs-callup-title">¡Felicitaciones!</h2>
                        {getFlagUrl(mundialCallup.pais) && <img className="cs-callup-flag" src={getFlagUrl(mundialCallup.pais)} alt={mundialCallup.pais} />}
                        <p className="cs-callup-text">
                            Fuiste convocado al <b>Mundial</b> con la selección de <b>{mundialCallup.pais}</b>.
                            <br />¡El sueño de todo futbolista! Dejá todo en la cancha. 🏆
                        </p>
                        <div className="cs-modal-actions">
                            <button className="cs-btn cs-btn-primary" onClick={() => setMundialCallup(null)}>¡Vamos!</button>
                        </div>
                    </div>
                </div>
            )}

            {showSeleccionModal && (() => {
                const sel = seleccionDelJugador(career);
                const estado = career?.seleccion;
                if (!sel) return null;
                const conv = isCalledUpSeleccion(career, sel);
                const grupoJ = estado?.grupos?.[estado.grupoJugadorIdx];
                const eliminado = estado?.fase === 'eliminado';
                const tabla = (grupoJ && !eliminado) ? ordenarStandingsSel(grupoJ.standings) : [];
                const proximos = eliminado ? [] : (estado?.calendarioJugador || []).filter(p => !p.jugado).slice(0, 4);
                const FASE_LABEL = {
                    clasif: '🟡 Eliminatorias en curso',
                    clasificado: '✅ Clasificado al Mundial',
                    playoff: '⚠️ A repechaje',
                    eliminado: '❌ Eliminado',
                };
                return (
                    <div className="cs-modal-overlay" onClick={() => setShowSeleccionModal(false)}>
                        <div className="cs-modal cs-seleccion-modal" onClick={(e) => e.stopPropagation()}>
                            <div className="cs-seleccion-head">
                                {getFlagUrl(sel.pais) && <img className="cs-flag cs-flag-big" src={getFlagUrl(sel.pais)} alt={sel.pais} />}
                                <div>
                                    <h2 className="cs-section-title">{sel.nombre}</h2>
                                    <div className="cs-seleccion-sub">{'★'.repeat(Math.floor(sel.estrellas))}{sel.estrellas % 1 ? '½' : ''} · FIFA #{sel.ranking} · {sel.confederacion}</div>
                                </div>
                            </div>
                            <div className={`cs-seleccion-callup ${conv ? 'is-on' : 'is-off'}`}>
                                {conv
                                    ? '⭐ Convocado a la selección'
                                    : '🚫 El DT todavía no te considera apto para convocarte a tu selección.'}
                            </div>
                            {estado && (
                                <>
                                    <div className="cs-seleccion-estado">
                                        {FASE_LABEL[estado.fase] || estado.fase}
                                        {' · Ciclo '}{estado.ciclo}{' / Año '}{estado.año_ciclo}{'/4'}
                                    </div>
                                    {eliminado && (
                                        <div className="cs-seleccion-afuera">
                                            ❌ Tu selección quedó afuera del Mundial.
                                            <div className="cs-seleccion-afuera-sub">No jugás más con la selección hasta las próximas clasificatorias (próximo ciclo).</div>
                                        </div>
                                    )}
                                    {tabla.length > 0 && (
                                        <div className="cs-seleccion-tabla-wrap">
                                            <h3 className="cs-seleccion-h3">Tabla del grupo</h3>
                                            <table className="cs-seleccion-tabla">
                                                <thead>
                                                    <tr><th>#</th><th>País</th><th>PJ</th><th>GF</th><th>GC</th><th>Pts</th></tr>
                                                </thead>
                                                <tbody>
                                                    {tabla.map((t, i) => (
                                                        <tr key={t.pais} className={t.pais === sel.pais ? 'mio' : ''}>
                                                            <td>{i + 1}</td>
                                                            <td>{getFlagUrl(t.pais) && <img className="cs-flag cs-flag-inline" src={getFlagUrl(t.pais)} alt={t.pais} />}{t.nombre || t.pais}</td>
                                                            <td>{t.pj}</td><td>{t.gf}</td><td>{t.gc}</td><td>{t.pts}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    {proximos.length > 0 && (
                                        <div className="cs-seleccion-proximos">
                                            <h3 className="cs-seleccion-h3">Próximos partidos</h3>
                                            {proximos.map((p, i) => (
                                                <div key={i} className="cs-seleccion-proximo">
                                                    Año {p.año} · {p.local ? 'vs' : '@'} {p.rival.nombre} ({'★'.repeat(Math.floor(p.rival.estrellas))})
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    <div className="cs-seleccion-stats">
                                        <span>📊 Este ciclo: <b>{estado.stats_ciclo?.partidos || 0}</b> PJ · <b>{estado.stats_ciclo?.goles || 0}</b> G · <b>{estado.stats_ciclo?.asistencias || 0}</b> A</span>
                                    </div>
                                    <div className="cs-seleccion-stats">
                                        <span>🌍 Carrera: <b>{career.seleccion_carrera?.partidos || 0}</b> PJ · <b>{career.seleccion_carrera?.goles || 0}</b> G · <b>{career.seleccion_carrera?.asistencias || 0}</b> A · <b>{career.seleccion_carrera?.mundiales_disputados || 0}</b> Mundiales</span>
                                    </div>
                                </>
                            )}
                            <div className="cs-modal-actions">
                                <button className="cs-btn cs-btn-secondary" onClick={() => setShowSeleccionModal(false)}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {showSeasonModal && seasonSummary && (
                <div className="cs-modal-overlay">
                    <div className="cs-modal" onClick={(e) => e.stopPropagation()}>
                        <h2 className="cs-section-title">Temporada {seasonSummary.temporada_anterior} finalizada</h2>

                        <p className="cs-season-line">
                            Terminaste {seasonSummary.posicion_final}º en {standings?.nombre || 'tu liga'}.
                        </p>

                        {seasonSummary.titulos?.length > 0 && (
                            <div className="cs-season-titles">
                                {seasonSummary.titulos.map((t) => (
                                    <p key={t} className="cs-season-line cs-season-title-win">🏆 {t}</p>
                                ))}
                            </div>
                        )}

                        {seasonSummary.stats && (
                            <div className="cs-season-stats">
                                <div className="cs-season-stat">
                                    <span className="cs-season-stat-value">{seasonSummary.stats.partidos}</span>
                                    <span className="cs-season-stat-label">Partidos</span>
                                </div>
                                <div className="cs-season-stat">
                                    <span className="cs-season-stat-value">{seasonSummary.stats.goles}</span>
                                    <span className="cs-season-stat-label">Goles</span>
                                </div>
                                <div className="cs-season-stat">
                                    <span className="cs-season-stat-value">{seasonSummary.stats.asistencias}</span>
                                    <span className="cs-season-stat-label">Asistencias</span>
                                </div>
                                <div className="cs-season-stat">
                                    <span className="cs-season-stat-value">{seasonSummary.stats.minutos_totales}'</span>
                                    <span className="cs-season-stat-label">Minutos</span>
                                </div>
                            </div>
                        )}

                        <p className="cs-season-line">
                            Valoración: {seasonSummary.rating_anterior} → {seasonSummary.rating_nuevo}{' '}
                            <span className={
                                seasonSummary.delta > 0 ? 'cs-rating-up' : seasonSummary.delta < 0 ? 'cs-rating-down' : 'cs-rating-same'
                            }>
                                {seasonSummary.delta > 0 ? `▲ +${seasonSummary.delta}` : seasonSummary.delta < 0 ? `▼ ${seasonSummary.delta}` : '='}
                            </span>
                        </p>

                        {seasonSummary.nuevo_valor_mercado != null && (
                            <p className="cs-season-line">
                                Valor de mercado: ${seasonSummary.nuevo_valor_mercado}M
                            </p>
                        )}

                        {seasonSummary.ascendio && (
                            <p className="cs-season-line">🔼 ¡Ascendiste a Primera División!</p>
                        )}
                        {seasonSummary.descendio && (
                            <p className="cs-season-line">🔽 Descendiste a Segunda División.</p>
                        )}

                        <div className="cs-modal-actions">
                            <button className="cs-btn cs-btn-primary" onClick={handleCloseSeasonModal}>
                                Continuar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showLiveMatchModal && liveMatch && (
                <div className="cs-modal-overlay">
                    <div className={`cs-modal cs-live-match${liveMatch.esSeleccion ? ' cs-live-match--seleccion' : ''}`} onClick={(e) => e.stopPropagation()}>
                        <h2 className="cs-section-title">
                            {liveMatch.header || `Jornada ${liveMatch.jornada} · ${liveMatch.local ? 'Local' : 'Visitante'}`}
                        </h2>

                        {liveMatch.idaResultado && (
                            <div className="cs-live-ida">
                                🔁 Vuelta · ida: <b>{liveMatch.idaResultado.favor}-{liveMatch.idaResultado.contra}</b> (global se define acá)
                            </div>
                        )}

                        <div className="cs-live-minute">{liveMatch.currentMinute}'</div>

                        <div className="cs-live-teams">
                            <div className="cs-live-team">
                                <ClubCrest logo={liveMatch.homeLogo} nombre={liveMatch.homeNombre} />
                                <span>{liveMatch.homeNombre}</span>
                            </div>
                            <div className="cs-live-score">{liveMatch.homeScore} - {liveMatch.awayScore}</div>
                            <div className="cs-live-team">
                                <ClubCrest logo={liveMatch.awayLogo} nombre={liveMatch.awayNombre} />
                                <span>{liveMatch.awayNombre}</span>
                            </div>
                        </div>

                        <div className="cs-live-goal-flash-wrap">
                            {goalFlash && <span className="cs-live-goal-flash">{goalFlash}</span>}
                        </div>

                        {liveMatch.finished ? (
                            liveMatch.penales ? (() => {
                                const miNombre = liveMatch.local ? liveMatch.homeNombre : liveMatch.awayNombre;
                                const rivalNombre = liveMatch.local ? liveMatch.awayNombre : liveMatch.homeNombre;
                                const revelados = liveMatch.penales.tanda.slice(0, liveMatch.penalStep);
                                const tiros = (favor) => revelados.filter((k) => k.favor === favor);
                                const goles = (favor) => tiros(favor).filter((k) => k.convertido).length;
                                const completo = liveMatch.penalStep >= liveMatch.penales.tanda.length;
                                const fila = (favor, nombre) => (
                                    <div className="cs-penales-row">
                                        <span className="cs-penales-team">{nombre}</span>
                                        <span className="cs-penales-kicks">
                                            {tiros(favor).map((k, i) => (
                                                <span
                                                    key={i}
                                                    className={`cs-penal-kick${k.convertido ? ' cs-penal-kick--ok' : ' cs-penal-kick--miss'}${k.muerte_subita ? ' cs-penal-kick--sd' : ''}`}
                                                    title={k.muerte_subita ? 'Muerte súbita' : ''}
                                                >
                                                    {k.convertido ? '⚽' : '✗'}
                                                </span>
                                            ))}
                                        </span>
                                        <span className="cs-penales-goles">{goles(favor)}</span>
                                    </div>
                                );
                                return (
                                    <div className="cs-penales">
                                        <div className="cs-penales-title">🥅 Definición por penales</div>
                                        {fila(true, miNombre)}
                                        {fila(false, rivalNombre)}
                                        {completo && (
                                            <div className={`cs-penales-result cs-penales-result--${liveMatch.penales.avanzo ? 'win' : 'lose'}`}>
                                                {liveMatch.penales.avanzo
                                                    ? `✅ ¡Avanzaste ${liveMatch.penales.favor}-${liveMatch.penales.contra} en los penales!`
                                                    : `❌ Eliminado ${liveMatch.penales.contra}-${liveMatch.penales.favor} en los penales`}
                                            </div>
                                        )}
                                        <div className="cs-modal-actions">
                                            <button className="cs-btn cs-btn-primary" onClick={handleLiveMatchClose} disabled={!completo}>
                                                {completo ? 'Continuar' : 'Pateando…'}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })() : (
                                <>
                                    {liveMatch.planFeedback && (
                                        <div className="cs-live-plan-feedback">{liveMatch.planFeedback}</div>
                                    )}
                                    <div className="cs-modal-actions">
                                        <button className="cs-btn cs-btn-primary" onClick={handleLiveMatchClose}>
                                            Continuar
                                        </button>
                                    </div>
                                </>
                            )
                        ) : (
                            <>
                                <div className="cs-live-goals">
                                    {liveMatch.events.filter((e) => e.minute <= liveMatch.currentMinute).map((e, i) => {
                                        const equipo = e.team === 'home' ? liveMatch.homeNombre : liveMatch.awayNombre;
                                        const txt = e.tipo === 'gol' ? '⚽ Gol tuyo'
                                            : e.tipo === 'asistencia' ? '🅰️ Asistencia tuya'
                                            : `⚽ ${equipo}`;
                                        return (
                                            <div className={`cs-live-goal-item${e.mio ? ' cs-live-goal-item--mio' : ''}`} key={i}>
                                                <span className="cs-live-goal-min">{e.minute}'</span> {txt}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="cs-live-progress">
                                    <div className="cs-live-progress-bar" style={{ width: `${(liveMatch.currentMinute / 90) * 100}%` }} />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            {eventoPendiente && (
                <div className="cs-modal-overlay">
                    <div className="cs-modal cs-evento-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="cs-evento-emoji">{eventoPendiente.emoji}</div>
                        <h2 className="cs-section-title">Evento</h2>
                        <p className="cs-evento-texto">{interp(eventoPendiente.texto, career)}</p>
                        {!eventoResultado ? (
                            <div className="cs-evento-opciones">
                                {eventoPendiente.opciones.map((op, i) => (
                                    <button key={i} className="cs-btn cs-btn-primary" onClick={() => resolverEvento(op)}>
                                        {interp(op.label, career)}
                                    </button>
                                ))}
                            </div>
                        ) : (
                            <>
                                <p className="cs-evento-resultado">{eventoResultado}</p>
                                <div className="cs-modal-actions">
                                    <button className="cs-btn cs-btn-primary" onClick={() => { setEventoPendiente(null); setEventoResultado(null); }}>
                                        Continuar
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            {showTacticasModal && career && (() => {
                const tac = { ...defaultTacticas(), ...(career.tacticas || {}) };
                const sc = proximoScouting();
                const EJES = [
                    { eje: 'formacion', label: 'Formación', opts: FORMACIONES },
                    { eje: 'actitud', label: 'Actitud', opts: ACTITUDES },
                    { eje: 'presion', label: 'Presión', opts: PRESIONES },
                    { eje: 'estilo', label: 'Estilo de ataque', opts: ESTILOS },
                    { eje: 'marca', label: 'Marca', opts: MARCAS },
                ];
                return (
                    <div className="cs-modal-overlay" onClick={() => setShowTacticasModal(false)}>
                        <div className="cs-modal cs-tac-modal" onClick={(e) => e.stopPropagation()}>
                            <h2 className="cs-section-title">📋 Pizarra táctica</h2>
                            {sc?.pista && <div className="cs-scouting">{sc.pista}{sc.rivalNombre ? ` (${sc.rivalNombre})` : ''}</div>}
                            {EJES.map(({ eje, label, opts }) => (
                                <div className="cs-tac-eje" key={eje}>
                                    <div className="cs-tac-eje-label">{label}</div>
                                    <div className="cs-tac-eje-opts">
                                        {opts.map((o) => (
                                            <button
                                                key={o}
                                                type="button"
                                                className={`cs-tac-btn${tac[eje] === o ? ' active' : ''}`}
                                                onClick={() => cambiarTactica(eje, o)}
                                            >
                                                {TACTICA_LABEL[o] || o}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                            <div className="cs-modal-actions">
                                <button className="cs-btn cs-btn-primary" onClick={() => setShowTacticasModal(false)}>
                                    Listo
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {showTransferModal && career?.ofertas_transferencia?.length > 0 && (
                <div className="cs-modal-overlay">
                    <div className="cs-modal" onClick={(e) => e.stopPropagation()}>
                        {(() => {
                            const expirado = (career.contrato_restante ?? 0) <= 0;
                            const hayRenovacion = career.ofertas_transferencia.some(o => o.es_renovacion);
                            let titulo = 'Ofertas de traspaso';
                            let texto = `Tenés ${career.ofertas_transferencia.length} oferta${career.ofertas_transferencia.length > 1 ? 's' : ''} de traspaso. ¿Qué querés hacer?`;
                            if (expirado && hayRenovacion) {
                                titulo = 'Se venció tu contrato';
                                texto = 'Tu club quiere renovarte, pero también te buscan otros equipos. Elegí renovar o fichar por otro club.';
                            } else if (expirado && !hayRenovacion) {
                                titulo = 'Tu club no te renueva';
                                texto = 'Tu club decidió no renovarte el contrato. Tenés que elegir sí o sí uno de los siguientes clubes.';
                            }
                            return (
                                <>
                                    <h2 className="cs-section-title">{titulo}</h2>
                                    <p className="cs-season-line">{texto}</p>
                                </>
                            );
                        })()}

                        <div className="cs-transfer-offers">
                            {career.ofertas_transferencia.map((oferta) => {
                                const min = oferta.minutos_esperados ?? 0;
                                const warning = min < 30
                                    ? `⚠️ Vas a jugar muy poco (~${min}'/partido)`
                                    : min < 60
                                        ? `🟡 Minutos limitados (~${min}'/partido)`
                                        : `✅ Titular (~${min}'/partido)`;
                                const anios = oferta.anios_contrato || 3;
                                const esRenovacion = oferta.es_renovacion;
                                return (
                                    <div className={`cs-transfer-offer${esRenovacion ? ' cs-transfer-offer--renovacion' : ''}`} key={oferta.tm_id}>
                                        <ClubCrest logo={oferta.logo} nombre={oferta.nombre} className="cs-transfer-offer-logo" />
                                        <div className="cs-transfer-offer-info">
                                            <span className="cs-transfer-offer-name">
                                                {oferta.nombre}
                                                {esRenovacion && <span className="cs-transfer-offer-tag"> · Renovación</span>}
                                            </span>
                                            <span className="cs-transfer-offer-meta">
                                                {oferta.liga_nombre} ({oferta.pais})
                                                {oferta.posicion_en_liga
                                                    ? ` · ${oferta.posicion_es_final ? 'terminó' : 'va'} ${oferta.posicion_en_liga}º`
                                                    : ''}
                                                {' · '}{'⭐'.repeat(Math.round(oferta.estrellas))}
                                            </span>
                                            <span className="cs-transfer-offer-monto">
                                                {esRenovacion ? `📝 Contrato ${anios} ${anios === 1 ? 'año' : 'años'}` : `${oferta.monto_millones}M · 📝 ${anios} ${anios === 1 ? 'año' : 'años'}`}
                                            </span>
                                            <span className={`cs-transfer-offer-minutes${min < 30 ? ' cs-transfer-offer-minutes--warn' : ''}`}>
                                                {warning}
                                            </span>
                                        </div>
                                        <button
                                            className="cs-btn cs-btn-primary"
                                            onClick={() => handleTransferDecision(oferta.tm_id)}
                                            disabled={decidingTransfer}
                                        >
                                            {esRenovacion ? 'Renovar' : 'Fichar'}
                                        </button>
                                    </div>
                                );
                            })}
                        </div>

                        {(career.contrato_restante ?? 0) > 0 && (
                            <div className="cs-modal-actions">
                                <button className="cs-btn cs-btn-secondary" onClick={() => handleTransferDecision(null)} disabled={decidingTransfer}>
                                    Quedarme en mi club
                                </button>
                            </div>
                        )}

                        {isAdmin && (
                            <button
                                type="button"
                                className="cs-btn cs-btn-secondary cs-btn-admin-club"
                                onClick={() => setShowAdminClubPicker(true)}
                                disabled={decidingTransfer}
                            >
                                🛠️ Admin: ir a cualquier club
                            </button>
                        )}
                    </div>
                </div>
            )}

            {showAdminClubPicker && isAdmin && (
                <div className="cs-modal-overlay" onClick={() => !adminClubLoading && setShowAdminClubPicker(false)}>
                    <div className="cs-modal cs-admin-club-picker" onClick={(e) => e.stopPropagation()}>
                        <h2 className="cs-section-title">🛠️ Admin: ir a cualquier club</h2>
                        <p className="cs-hint">Solo para testing. Te ficha de una en el club que elijas, sin pasar por ofertas.</p>
                        <input
                            type="text"
                            className="cs-input"
                            placeholder="Buscar club, liga o país..."
                            value={adminClubSearch}
                            onChange={(e) => setAdminClubSearch(e.target.value)}
                            autoFocus
                        />
                        <div className="cs-admin-club-list">
                            {getAllClubsFlat(career)
                                .filter((club) => {
                                    const q = adminClubSearch.trim().toLowerCase();
                                    if (!q) return true;
                                    return (
                                        club.nombre.toLowerCase().includes(q) ||
                                        club.pais.toLowerCase().includes(q) ||
                                        club.liga_nombre.toLowerCase().includes(q)
                                    );
                                })
                                .map((club) => (
                                    <div className="cs-admin-club-row" key={`${club.pais}-${club.division}-${club.tm_id}`}>
                                        <ClubCrest logo={club.logo} nombre={club.nombre} />
                                        <div className="cs-club-info">
                                            <div className="cs-club-name">{club.nombre}</div>
                                            <div className="cs-club-meta">{club.liga_nombre} · {club.pais} · D{club.division}</div>
                                        </div>
                                        <button
                                            className="cs-btn cs-btn-primary cs-btn-elegir"
                                            onClick={() => handleAdminGoToClub(club)}
                                            disabled={adminClubLoading}
                                        >
                                            Ir
                                        </button>
                                    </div>
                                ))}
                        </div>
                        <div className="cs-modal-actions">
                            <button className="cs-btn cs-btn-secondary" onClick={() => setShowAdminClubPicker(false)} disabled={adminClubLoading}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showRetireModal && career && (() => {
                const { clubs, totales } = buildTrayectoria();
                return (
                    <div className="cs-modal-overlay">
                        <div className="cs-modal cs-retire-modal" onClick={(e) => e.stopPropagation()}>
                            {forcedRetire && (
                                <div className="cs-retire-banner">A los {career.edad} años decís adiós al fútbol profesional. ¡Qué carrera!</div>
                            )}

                            {/* Tarjeta con el MISMO diseño que la imagen para compartir */}
                            <div className="cs-share-card">
                                <div className="cs-share-cardtitle">⚽ FOOTY · MODO CARRERA</div>

                                <div className="cs-share-header">
                                    <div className="cs-share-col cs-share-col--avatar">
                                        <PlayerAvatar avatar={career.avatar} size={132} altura={career.altura} peso={career.peso} />
                                    </div>
                                    <div className="cs-share-col cs-share-col--bio">
                                        <div className="cs-share-name">{career.nombre}</div>
                                        <div className="cs-share-pos">{career.posicion}</div>
                                        <div className="cs-share-meta">{career.nacionalidad}</div>
                                        <div className="cs-share-meta">{totales.temporadas} temporada{totales.temporadas !== 1 ? 's' : ''} · {career.edad} años</div>
                                    </div>
                                    <div className="cs-share-col cs-share-col--rating">
                                        <div className="cs-share-disc">{totales.mejorRating}</div>
                                        <div className="cs-share-disc-lbl">MEJOR MEDIA</div>
                                    </div>
                                </div>

                                <div className="cs-share-sectitle"><span>Estadísticas</span></div>
                                <div className="cs-share-stats">
                                    <div className="cs-share-stat"><span className="cs-share-stat-val">{totales.partidos}</span><span className="cs-share-stat-lbl">PARTIDOS</span></div>
                                    <div className="cs-share-stat"><span className="cs-share-stat-val">{totales.goles}</span><span className="cs-share-stat-lbl">GOLES</span></div>
                                    <div className="cs-share-stat"><span className="cs-share-stat-val">{totales.asistencias}</span><span className="cs-share-stat-lbl">ASISTENCIAS</span></div>
                                    <div className="cs-share-stat"><span className="cs-share-stat-val">{totales.titulos}</span><span className="cs-share-stat-lbl">TÍTULOS</span></div>
                                </div>

                                <div className="cs-share-sectitle"><span>Palmarés</span></div>
                                <div className="cs-share-chips">
                                    <span className="cs-share-chip">🏆 {totales.ligas} {totales.ligas === 1 ? 'Liga' : 'Ligas'}</span>
                                    {totales.champions > 0 && <span className="cs-share-chip">🏆 {totales.champions} Champions</span>}
                                    {totales.europa > 0 && <span className="cs-share-chip">🌍 {totales.europa} Europa L.</span>}
                                    {totales.libertadores > 0 && <span className="cs-share-chip">🏆 {totales.libertadores} Libertadores</span>}
                                    {totales.sudamericana > 0 && <span className="cs-share-chip">🥈 {totales.sudamericana} Sudamericana</span>}
                                </div>

                                {(() => {
                                    const r = buildSeleccionResumen();
                                    if (!r) return null;
                                    return (
                                        <>
                                            <div className="cs-share-sectitle"><span>Selección Nacional</span></div>
                                            <div className="cs-share-seleccion-head">
                                                {getFlagUrl(r.pais) && <img className="cs-share-flag" src={getFlagUrl(r.pais)} alt={r.pais} />}
                                                <span className="cs-share-seleccion-nombre">{r.nombre}</span>
                                                <span className="cs-share-seleccion-estr">{'★'.repeat(Math.floor(r.estrellas))}{r.estrellas % 1 ? '½' : ''}</span>
                                            </div>
                                            <div className="cs-share-chips">
                                                <span className="cs-share-chip">🌍 {r.mundiales_disputados} {r.mundiales_disputados === 1 ? 'Mundial' : 'Mundiales'}</span>
                                                <span className="cs-share-chip">⚽ {r.goles} Goles</span>
                                                <span className="cs-share-chip">🅰️ {r.asistencias} Asist.</span>
                                                <span className="cs-share-chip">📋 {r.partidos} PJ</span>
                                            </div>
                                            {r.mejor && (
                                                <div className="cs-share-seleccion-mejor">
                                                    Mejor: Mundial ciclo {r.mejor.ciclo} (edad {r.mejor.edad_jugador}) — {LLEGO_LABEL[r.mejor.llego_a] || r.mejor.llego_a}
                                                    {r.mejor.llego_a === 'campeon' && r.mejor.pais_jugador ? ` con ${r.mejor.pais_jugador}` : ''}
                                                </div>
                                            )}
                                            {r.mundiales.length > 0 && (
                                                <div className="cs-share-seleccion-list">
                                                    {r.mundiales.map((m, i) => (
                                                        <div key={i} className="cs-share-seleccion-row">
                                                            <span>Mundial #{m.ciclo} · edad {m.edad_jugador}</span>
                                                            <span className="cs-share-seleccion-row-r">{LLEGO_LABEL[m.llego_a] || m.llego_a}{m.llego_a === 'campeon' ? '' : (m.partidos ? ` · ${m.partidos} PJ ${m.goles}G` : '')}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </>
                                    );
                                })()}

                                <div className="cs-share-sectitle"><span>Trayectoria</span></div>
                                <div className="cs-share-traj">
                                    {clubs.map((c, i) => (
                                        <div className="cs-share-club" key={`${c.nombre}-${i}`}>
                                            <ClubCrest logo={c.logo} nombre={c.nombre} className="cs-share-club-logo" />
                                            <div className="cs-share-club-info">
                                                <span className="cs-share-club-name">{c.nombre}</span>
                                                {c.edadDesde != null && (
                                                    <span className="cs-share-club-age">
                                                        {c.edadDesde === c.edadHasta ? `${c.edadDesde} años` : `${c.edadDesde}–${c.edadHasta} años`}
                                                    </span>
                                                )}
                                            </div>
                                            <span className="cs-share-club-stats">{c.partidos} PJ · {c.goles} ⚽ · {c.asistencias} 🅰️</span>
                                        </div>
                                    ))}
                                </div>

                                <div className="cs-share-footer">Jugá tu carrera en www.footy-games.com.ar</div>
                            </div>

                            <div className="cs-modal-actions cs-retire-actions">
                                <button className="cs-btn cs-btn-share" onClick={() => shareCareerImage()} disabled={sharing}>
                                    {sharing ? 'Generando…' : '📸 Compartir'}
                                </button>
                                <button className="cs-btn cs-btn-download" onClick={() => downloadCareerImage()} disabled={sharing}>
                                    {sharing ? 'Generando…' : '📥 Descargar'}
                                </button>
                                {!forcedRetire && (
                                    <button className="cs-btn cs-btn-secondary" onClick={() => setShowRetireModal(false)} disabled={loadingAction}>
                                        Volver
                                    </button>
                                )}
                                <button className="cs-btn cs-btn-danger" onClick={confirmRetire} disabled={loadingAction}>
                                    {forcedRetire ? 'Empezar nueva carrera' : 'Confirmar retiro'}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {showNationalityModal && (
                <div className="cs-modal-overlay" onClick={() => setShowNationalityModal(false)}>
                    <div className="cs-modal cs-nationality-modal" onClick={(e) => e.stopPropagation()}>
                        <h2 className="cs-section-title">Elegí tu nacionalidad</h2>
                        <div className="cs-nationality-grid">
                            {[...NATIONALITIES].sort((a, b) => a.localeCompare(b, 'es')).map((n) => {
                                const est = SELECCIONES_BY_PAIS[n]?.estrellas;
                                return (
                                    <button
                                        key={n}
                                        type="button"
                                        className={`cs-nationality-option${form.nacionalidad === n ? ' active' : ''}`}
                                        onClick={() => {
                                            setForm({ ...form, nacionalidad: n });
                                            setShowNationalityModal(false);
                                        }}
                                    >
                                        {getFlagUrl(n) && <img className="cs-flag" src={getFlagUrl(n)} alt={n} />}
                                        <span className="cs-nat-info">
                                            <span className="cs-nat-name">{n}</span>
                                            {est != null && <MiniStars value={est} />}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                        <div className="cs-modal-actions">
                            <button className="cs-btn cs-btn-secondary" onClick={() => setShowNationalityModal(false)}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
            </div>
        </div>
    );
}

export default CareerSimulatorPage2;
